// FinanceTaxInvoice
import React, { Component } from "react";
import axios from "axios";
import NumberFormat from "react-number-format";
import { APIURL, PORT } from "../../../config/config";
import { connect } from "react-redux";
import * as moment from "moment";
import "moment/locale/th";
import ThaiBaht from "thai-baht-text";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import DatePicker from "react-datepicker";
import { AlertError, AlertSuccess, AlertWarning } from "../../Alert/Alert";
import { DateUtil } from "../../../utils/dateUtil";
import { NumberUtil } from "../../../utils/number-util";
import FinanceModal from "../FinanceModal";
import CustomerModal from "../CustomerModal";
import Loading from "../../Loading";
import { getDocTypeConfig } from "../../../services/companysetting";
import Swal from "sweetalert2";
import {
  checkDocNo,
  setInputStyleDocNo,
} from "../../../services/docLogService";
// import { getCompanySetting, getDocTypeConfig } from '../../../services/companysetting'
// import { Alert } from 'reactstrap'
// import { Redirect, Link } from 'react-router-dom';
import { PDFUtil } from "../../../utils/pdfUtil";

pdfMake.vfs = pdfFonts;
pdfMake.fonts = PDFUtil.getCustomFonts();

const port = Number(window.env.PORT);

class FinanceTaxInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      // activeTab: '1',
      car_sell: {},
      car_sell_id: "",
      // car: {},
      // car_brand: {},
      // car_id: '',
      isLoading: false,
      isExist: false,
      // new
      isFinanceModal: false,
      isGeneralModal: false,
      startDateInvoice: new Date(), // moment(),
      isOpenDateInvoice: false,
      date_receive_thai: null,
      // customer
      customer_type: "finance",
      tax_customer_id: "",
      tax_invoice_name: "",
      tax_invoice_address1: "",
      tax_invoice_address2: "",
      tax_invoice_tax_id: "",
      //
      tax_invoice_date: null,
      tax_invoice_no: "",
      tax_invoice_number: "",
      tax_invoice_amount: 0,
      tax_invoice_vat: 0,
      tax_invoice_total: 0,
      tax_invoice_payee: "",
      carBase64Img: "",
      sealBase64Img: "",
      gearbox_warranty: "",
      gearbox_amount: 0,
      debt_insurance_amount: 0,
      code_item: "",
      //
      company_setting: null,
      doc_type: "",
      doc_config: "",
      is_vat: 0,
      include_vat: 0,
      doc_no: "",
      tax_invoice_status: "nodata",
      bank_finance_id: "",
      use_old_license: 0,
      car_license_plate_old: "",
      province_name_old: "",
      check_doc_no: "",
      car_sell_type_id: 0,
      tax_invoice_number_current: null,
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.loadCompanySetting = this.loadCompanySetting.bind(this);
    this.loadCarSellById = this.loadCarSellById.bind(this);
    this.handleDateReceive = this.handleDateReceive.bind(this);
    this.toggleCustomerFinanceModal =
      this.toggleCustomerFinanceModal.bind(this);
    this.toggleCustomerGeneralModal =
      this.toggleCustomerGeneralModal.bind(this);
    this.saveTaxInvoice = this.saveTaxInvoice.bind(this);
    this.printTaxInvoice = this.printTaxInvoice.bind(this);
    this.printTaxInvoice2 = this.printTaxInvoice2.bind(this);
    this.loadCompanyLogoBase64 = this.loadCompanyLogoBase64.bind(this);
    this.loadCompanySealBase64 = this.loadCompanySealBase64.bind(this);
    this.calInvoice = this.calInvoice.bind(this);
    this.printTaxInvoiceCodeItem = this.printTaxInvoiceCodeItem.bind(this);
    this.printTaxInvoiceNoLine = this.printTaxInvoiceNoLine.bind(this);
    this.cancelTaxInvoice = this.cancelTaxInvoice.bind(this);
    this.checkTaxInvoiceNumberRepeat =
      this.checkTaxInvoiceNumberRepeat.bind(this);
    this.genNetTotal = this.genNetTotal.bind(this);
    this.genCarPrice = this.genCarPrice.bind(this);
    this.calPriceBeforeVat = this.calPriceBeforeVat.bind(this);
    this.genSellNameBuy = this.genSellNameBuy.bind(this);
    this.genSellNameBuyDetail = this.genSellNameBuyDetail.bind(this);
  }

  async loadCarSellById(car_sell_id, is_reload) {
    // console.log('car_sell_id=', car_sell_id)

    await axios
      .get(APIURL + "/car_sell/" + car_sell_id)
      .then((res) => {
        if (this.mounted) {
          let car_sell = res.data[0];
          let car_sell_date = car_sell.car_sell_date;
          let date = new Date(car_sell_date);
          let date_receive = moment(date).format("YYYY-MM-DD");

          let vatPercent = this.state.company_setting.vat / 100.0;
          let vatBeforePercent =
            this.state.company_setting.vat /
            (100 + this.state.company_setting.vat);

          let tax_invoice_vat = 0;
          let tax_invoice_total = 0;
          let rate_finance = 0;

          //let real_sell_price =0
          let car_sell_type_id = Number(car_sell.car_sell_type_id);
          let tax_invoice_amount = 0;
          let tax_invoice_number_current = null;

          if (
            car_sell.tax_customer_id === null ||
            car_sell.tax_customer_id === 0
          ) {
            // real_sell_price = car_sell.real_sell_price;
            // ปรับใช้เป็นยอดจัด rate_finance แทน
            //real_sell_price
            //car_sell_type_id
            rate_finance = Number(car_sell.tax_invoice_amount);

            if (car_sell_type_id === 1) {
              // real_sell_price เท่ากับยอดขายเงินสดรวม vat แล้ว
              rate_finance = Number(car_sell.real_sell_price);
              tax_invoice_total = rate_finance;
              let tax_invoice_vat_before = tax_invoice_total * vatBeforePercent;
              tax_invoice_vat = Number(tax_invoice_vat_before.toFixed(2));
              tax_invoice_amount = tax_invoice_total - tax_invoice_vat;
            } else {
              //car_sell_type_id === 2 จัดไฟแนนซ์
              if (car_sell.tax_invoice_amount === 0) {
                rate_finance = Number(car_sell.rate_finance);
              }
              tax_invoice_amount = rate_finance;
              tax_invoice_vat = rate_finance * vatPercent;
              let tax_invoice_vat_fix = Number(tax_invoice_vat.toFixed(2));
              tax_invoice_total = rate_finance + tax_invoice_vat_fix;
            }
          } else {
            //กรณีบันทึกแล้ว
            tax_invoice_amount = Number(car_sell.tax_invoice_amount);
            tax_invoice_vat = Number(car_sell.tax_invoice_vat);
            tax_invoice_total = Number(car_sell.tax_invoice_total);
            tax_invoice_number_current = car_sell.tax_invoice_number;
          }

          let customer_type = car_sell.customer_type;
          let tax_invoice_date =
            car_sell.tax_invoice_date === null
              ? date_receive
              : moment(car_sell.tax_invoice_date).format("YYYY-MM-DD");

          let tax_customer_id = car_sell.tax_customer_id;
          let tax_invoice_name = car_sell.tax_invoice_name;
          let tax_invoice_address1 = car_sell.tax_invoice_address1;
          let tax_invoice_address2 = car_sell.tax_invoice_address2;
          let tax_invoice_tax_id = car_sell.tax_invoice_tax_id;
          let tax_invoice_payee = car_sell.tax_invoice_payee;
          let tax_invoice_no = car_sell.tax_invoice_no;
          let tax_invoice_number = car_sell.tax_invoice_number;
          let tax_invoice_status = car_sell.tax_invoice_status;
          let use_old_license = car_sell.use_old_license;

          let code_item = car_sell.code_item;

          let date_receive_thai =
            DateUtil.convertLongDateThai(tax_invoice_date);

          let gearbox_amount = car_sell.gearbox_amount;
          let debt_insurance_amount = car_sell.debt_insurance_amount;

          if (port === 9035) {
            tax_invoice_amount =
              Number(tax_invoice_amount) +
              Number(gearbox_amount) +
              Number(debt_insurance_amount);
          }

          if (is_reload) {
            this.props.onReloadCarSell(car_sell, false);
          }

          let isExist =
            tax_customer_id === null ||
            tax_customer_id === "" ||
            tax_customer_id === 0
              ? false
              : true;

          //console.log('tax_customer_id=',tax_customer_id)
          //console.log('isExist=',isExist)

          this.setState(
            {
              isExist: isExist,
              car_sell: car_sell,
              car_sell_id: car_sell_id,
              startDateCarSell: date,
              tax_invoice_date: tax_invoice_date,
              date_receive_thai: date_receive_thai,
              tax_invoice_vat: tax_invoice_vat,
              tax_invoice_amount: tax_invoice_amount,
              tax_invoice_total: tax_invoice_total,
              tax_invoice_status: tax_invoice_status,
              // tax_invoice_date,
              // tax_invoice_vat,
              // tax_invoice_amount,
              // tax_invoice_total,
              tax_customer_id,
              tax_invoice_name,
              tax_invoice_address1,
              tax_invoice_address2,
              tax_invoice_tax_id,
              tax_invoice_payee,
              tax_invoice_no,
              tax_invoice_number,
              code_item,

              gearbox_amount: gearbox_amount,
              debt_insurance_amount: debt_insurance_amount,
              use_old_license,
              car_license_plate_old: car_sell.car_license_plate_old,
              province_name_old: car_sell.province_name_old,
              car_sell_type_id,
              customer_type: car_sell.customer_type,
              tax_invoice_number_current: tax_invoice_number_current,
            },
            () => {
              //console.log('customer_type =', customer_type)
              //console.log('this.state.customer_type =', this.state.customer_type)
              /*if (customer_type !== this.state.customer_type) {
                this.setState({
                  customer_type: customer_type,
                })
              }*/

              if (car_sell_type_id === 2 && tax_invoice_status === "nodata") {
                let bank_finance_id = car_sell.bank_finance_id;
                // console.log('bank_finance =', bank_finance)
                this.setState(
                  {
                    customer_type: "finance",
                    bank_finance_id: bank_finance_id,
                  },
                  () => {
                    this.loadFinanceById();
                  }
                );
              } else if (
                car_sell_type_id === 1 &&
                tax_invoice_status === "nodata"
              ) {
                let customer_id = car_sell.customer_id;

                this.setState(
                  {
                    customer_type: "customer",
                    customer_id: customer_id,
                  },
                  () => {
                    this.loadCustomerById();
                  }
                );
              }
            }
          );
        }
      })
      .catch((error) => {
        //alert('error' + error)
        console.log(error);
        this.setState({ car_sell: {} });
      });
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  async componentDidMount() {
    this.mounted = true;

    // const queryString = require('query-string')
    // let car_sell = queryString.parse(this.props.location.search)
    // let car_sell_id =  car_sell.car_sell_id

    let car_sell_id = this.props.car_sell_id;
    await this.loadCompanyLogoBase64();

    if (port === 9008) {
      await this.loadCompanySealBase64();
    }

    await this.loadCompanySetting();
    await this.loadCarSellById(car_sell_id, false);

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  /*componentDidUpdate(prevProps, prevState, snapshot) {
    //tax_invoice_status: 'nodata'
    //console.log("tax_invoice_status 1 =", prevProps.tax_invoice_status)
    //console.log("tax_invoice_status 2 =", this.props.tax_invoice_status)
    //console.log("tax_invoice_status 3 =", this.state.tax_invoice_status)
    /!*if(prevProps.tax_invoice_status !== null && this.props.tax_invoice_status !== this.state.tax_invoice_status){
      console.log("update =", this.props.tax_invoice_status)
      this.setState({
        tax_invoice_status : this.props.tax_invoice_status
      }, async ()=>{
        let car_sell_id =  this.props.car_sell_id
        console.log('componentDidUpdate car_sell_id=',car_sell_id)
        // await this.loadCarSellById();
        await this.loadCompanySetting();
        await this.loadCarSellById(car_sell_id, false);
      })
    }*!/
  }*/

  componentWillMount() {
    // const queryString = require('query-string');
    this.setState({
      user: JSON.parse(this.props.user),
    });
  }

  async loadCompanyLogoBase64() {
    let uri = APIURL + "/company_setting/logoimage/1";
    await axios
      .get(uri)
      .then((res) => {
        let body = res.data.body;
        this.setState({ carBase64Img: body });
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  async loadCompanySealBase64() {
    let uri = APIURL + "/company_setting/companyseal/1";
    await axios
      .get(uri)
      .then((res) => {
        let body = res.data.body;
        this.setState({ sealBase64Img: body });
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  async loadCompanySetting() {
    await axios.get(APIURL + "/company_setting/1").then((res) => {
      let data = res.data;
      let company_setting = data.company_setting;
      if (company_setting !== null) {
        const is_vat = company_setting.is_vat;
        const doc_type = is_vat === 1 ? "RT" : "RE";
        const doc_config = getDocTypeConfig(company_setting, doc_type);
        const include_vat = is_vat === 1 ? 1 : 0;

        /*let data = {
            doc_type: doc_type,
            doc_config: doc_config,
            is_vat: is_vat,
            include_vat: include_vat
          }
          */

        this.setState({
          company_setting: company_setting,
          doc_type: doc_type,
          doc_config: doc_config,
          is_vat: is_vat,
          include_vat: include_vat,
        });
      }
    });
  }

  loadFinanceById() {
    let bank_finance_id = this.state.bank_finance_id;

    axios
      .get(APIURL + "/bank/" + bank_finance_id)
      .then((res) => {
        //this.setState({bank: res.data})
        //console.log('bank=', res.data)

        if (res.data.length === 1) {
          let bank = res.data[0];
          const bank_id = bank.bank_id;
          const tax_invoice_name = bank.bank_name_full;
          const tax_invoice_address1 = bank.bank_address_line1;
          const tax_invoice_address2 = bank.bank_address_line2;
          const tax_invoice_tax_id = bank.bank_tax_id;

          this.setState({
            tax_customer_id: bank_id,
            tax_invoice_name: tax_invoice_name,
            tax_invoice_address1: tax_invoice_address1,
            tax_invoice_address2: tax_invoice_address2,
            tax_invoice_tax_id: tax_invoice_tax_id,
            // tax_customer: bank
          });
        }
      })
      .catch((error) => {
        //this.setState({bank: []})
      });
  }

  loadCustomerData() {
    axios
      .get(APIURL + "/customer/" + this.state.customer_id)
      .then((res) => {
        //console.log(res.data)
        this.setState({ customer: res.data[0] });
      })
      .catch((error) => {
        alert("พบข้อผิดพลาด : " + error);
        this.setState({ customer: {} });
      });
  }

  loadCustomerById() {
    let customer_id = this.state.customer_id;

    axios
      .get(APIURL + "/customer/" + this.state.customer_id)
      .then((res) => {
        //this.setState({bank: res.data})
        //console.log('customer=', res.data)

        if (res.data.length === 1) {
          let customer = res.data[0];
          const customer_id = customer.customer_id;
          const tax_invoice_name =
            customer.customer_name + " " + " " + customer.customer_lastname;
          const tax_invoice_address1 = customer.customer_address;
          //const tax_invoice_address2 = bank.bank_address_line2
          const tax_invoice_tax_id = customer.customer_card_id;

          this.setState({
            tax_customer_id: customer_id,
            tax_invoice_name: tax_invoice_name,
            tax_invoice_address1: tax_invoice_address1,
            tax_invoice_tax_id: tax_invoice_tax_id,
          });
        }
      })
      .catch((error) => {
        //this.setState({bank: []})
      });
  }

  toggleCustomerFinanceModal(status, bank) {
    this.setState({
      isFinanceModal: status,
    });

    if (bank !== null) {
      const bank_id = bank.bank_id;
      const tax_invoice_name = bank.bank_name_full;
      const tax_invoice_address1 = bank.bank_address_line1;
      const tax_invoice_address2 = bank.bank_address_line2;
      const tax_invoice_tax_id = bank.bank_tax_id;

      this.setState({
        tax_customer_id: bank_id,
        tax_invoice_name: tax_invoice_name,
        tax_invoice_address1: tax_invoice_address1,
        tax_invoice_address2: tax_invoice_address2,
        tax_invoice_tax_id: tax_invoice_tax_id,
        // tax_customer: bank
      });
    }
  }

  toggleCustomerGeneralModal(status, customer) {
    this.setState({
      isGeneralModal: status,
    });

    if (customer !== null) {
      const customer_id = customer.customer_id;
      const tax_invoice_name =
        customer.customer_name + " " + " " + customer.customer_lastname;
      const tax_invoice_address1 = customer.customer_address;
      const tax_invoice_address2 = "";
      const tax_invoice_tax_id = customer.customer_card_id;

      this.setState({
        tax_customer_id: customer_id,
        tax_invoice_name: tax_invoice_name,
        tax_invoice_address1: tax_invoice_address1,
        tax_invoice_address2: tax_invoice_address2,
        tax_invoice_tax_id: tax_invoice_tax_id,
      });
    }
  }

  printTaxInvoice(isCopy) {
    const {
      company_setting,
      date_receive_thai,
      carBase64Img,
      sealBase64Img,
      tax_invoice_name,
      tax_invoice_address1,
      tax_invoice_address2,
      tax_invoice_tax_id,
      tax_invoice_total,
      tax_invoice_vat,
      tax_invoice_payee,
      use_old_license,
      car_sell,
    } = this.state;
    // let moneyText = ThaiBaht(car_sell_pay.car_sell_pay_count)
    let car_brand_name = car_sell.car_brand_name;
    let car_model_name = car_sell.car_model_name;
    let car_sub_model_name = car_sell.car_sub_model_name;

    let car_name2 =
      car_brand_name + " " + car_model_name + " " + car_sub_model_name;

    if (car_sub_model_name.indexOf(car_model_name) !== -1) {
      // มีชื่อรุ่นใน รุ่นย่อย
      car_name2 = car_brand_name + " " + car_sub_model_name;
    } else if (car_model_name.indexOf(car_brand_name) !== -1) {
      car_name2 = car_model_name + " " + car_sub_model_name;
    }

    let taxInvoicePayee;
    if (tax_invoice_payee === null || tax_invoice_payee === "") {
      taxInvoicePayee = [
        {
          text: "(.........................................................)",
          style: "smallCenter",
        },
      ];
    } else {
      taxInvoicePayee = [
        { text: "( " + tax_invoice_payee + " )", style: "smallCenter" },
      ];
    }

    let company_name = company_setting.company_name;
    let company_address = company_setting.company_address;
    let juristic_number = company_setting.juristic_number;
    let company_tel =
      company_setting.company_tel === "" ? "-" : company_setting.company_tel;
    let doc_type = isCopy ? "( สำเนา )" : "( ต้นฉบับ )";

    let tax_invoice_total_text = ThaiBaht(tax_invoice_total);
    let tax_invoice_amount = parseFloat(
      Number(this.state.tax_invoice_amount)
    ).toFixed(2);
    let tax_invoice_no = this.state.tax_invoice_no;
    let tax_invoice_number =
      this.state.tax_invoice_number === null
        ? "-"
        : this.state.tax_invoice_number;

    let head_line3 =
      "โทร. " + company_tel + " เลขประจำตัวผู้เสียภาษี " + juristic_number;

    let invoiceNoRow;
    if (
      tax_invoice_no === null ||
      tax_invoice_no === "" ||
      tax_invoice_no === "-"
    ) {
      invoiceNoRow = [
        { text: "", style: "normalNo", margin: [0, 15, 0, 0] },
        {
          text: "เลขที่ " + tax_invoice_number,
          style: "normalRightBold",
          colSpan: 2,
          margin: [0, 15, 0, 0],
        },
        "",
      ];
    } else {
      // {text: '', style: 'normalCenter'},
      invoiceNoRow = [
        {
          text: "เล่มที่ " + tax_invoice_no,
          style: "normalNo",
          margin: [0, 15, 0, 0],
        },
        {
          text: "เลขที่ " + tax_invoice_number,
          style: "normalRightBold",
          colSpan: 2,
          margin: [0, 15, 0, 0],
        },
        "",
      ];
    }

    let vatPercentText =
      this.state.company_setting === null
        ? "-"
        : String(this.state.company_setting.vat);

    let headerLeft;
    let headerCenter;
    if (Number(port) === 9008) {
      // roddee
      headerLeft = {
        text:
          company_name +
          "\n" +
          company_address +
          "\n" +
          "เลขประจำตัวผู้เสียภาษี " +
          juristic_number,
        style: "textBoldHead",
        colSpan: 2,
      };
      // headerLeft = {
      //   image: sealBase64Img, width: 100
      // }
      //headerCenter = company_name+'\n'+company_address+'\n'+ 'เลขประจำตัวผู้เสียภาษี '+juristic_number
    } else {
      let logo_width = 110;
      if (company_address.length >= 60 || head_line3.length >= 60) {
        logo_width = 100;
      } else if (company_address.length >= 57 || head_line3.length >= 57) {
        logo_width = 96;
      }

      if (port === 9000) {
        logo_width = 80;
      }

      headerLeft = {
        image: carBase64Img,
        width: logo_width,
      };
      headerCenter = company_name + "\n" + company_address + "\n" + head_line3;
    }

    let imageEmptySeal = {
      image: "emptySeal",
      width: 100,
      border: [false, false, false, false],
      rowSpan: 3,
    };

    let car_license_new =
      car_sell.car_license_plate_new + " " + car_sell.province_name_new;
    let car_license_old =
      car_sell.car_license_plate_old + " " + car_sell.province_name_old;
    let car_license = use_old_license === 1 ? car_license_old : car_license_new;

    let carName;
    if (port === 9008) {
      carName = [
        {
          text: "1",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            { width: "25%", text: "ค่ารถยนต์", style: "myCellSmall" },
            {
              width: "75%",
              style: "myCellSmall",
              text: car_sell.car_brand_name + " " + car_sell.car_sub_model_name,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        {
          text: NumberUtil.addCommas(String(tax_invoice_amount)),
          style: "myCellPrice",
        },
      ];
    } else {
      carName = [
        {
          text: "1",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            { width: "25%", text: "ค่ารถยนต์", style: "myCellSmall" },
            { width: "75%", style: "myCellSmall", text: car_name2 },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        {
          text: NumberUtil.addCommas(String(tax_invoice_amount)),
          style: "myCellPrice",
        },
      ];
    }

    // pageMargins : [left, top, right, bottom]
    let docDefinition = {
      pageOrientation: "portrait",
      pageSize: "A4",
      pageMargins: [40, 35, 40, 0],
      // background: {image: 'book', width: 600},
      content: [
        {
          table: {
            widths: ["15%", "70%", "15%"],
            body: [
              [
                headerLeft,
                {
                  text: headerCenter,
                  style: "textBoldHead",
                  margin: [50, 4, 0, 0],
                  colSpan: 2,
                },
                { text: "", style: "normal" },
              ],
              [
                { text: "", style: "normalCenter" },
                {
                  text: "ใบเสร็จรับเงิน / ใบกำกับภาษี",
                  style: "textBoldCenter",
                  margin: [0, 25, 0, 0],
                },
                { text: "", style: "normalRight" },
              ],
              [
                { text: " ", style: "normalCenter" },
                { text: doc_type, style: "normalCenter" },
                { text: " ", style: "normalRight" },
              ],
              invoiceNoRow,
              // [
              //   {text: ' ' , style: 'normalCenter'},
              //   {text: '', style: 'normalCenter'},
              //   {text: ' ', style: 'normalRight'},
              // ],
              [
                { text: " ", style: "normalCenter" },
                {
                  text: "วันที่ " + date_receive_thai,
                  style: "normalRight",
                  colSpan: 2,
                },
                "",
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          columns: [
            { width: "15%", text: "นามลูกค้า", style: "textBold" },
            { width: "85%", style: "normal", text: tax_invoice_name },
          ],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          columns: [
            { width: "15%", text: "ที่อยู่", style: "textBold" },
            { width: "85%", style: "normal", text: tax_invoice_address1 },
          ],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          columns: [
            { width: "15%", text: "", style: "normal" },
            { width: "85%", style: "normal", text: tax_invoice_address2 },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 0, 0, 0],
        },
        {
          columns: [
            { width: "15%", text: "", style: "normal" },
            {
              width: "85%",
              style: "normal",
              text: "เลขประจำตัวผู้เสียภาษี " + tax_invoice_tax_id,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 0, 0, 20],
        },
        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: ["14%", "48%", "22%", "16%"],
            // heights: [20, 30],
            body: [
              [
                { text: "จำนวน", style: "myCellBold" },
                { text: "รายการ", style: "myCellBold", colSpan: 2 },
                "",
                { text: "จำนวนเงิน", style: "myCellBold" },
              ],
              carName,
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    {
                      width: "25%",
                      text: "ปี " + car_sell.car_year_name,
                      style: "myCellSmall",
                    },
                    {
                      width: "75%",
                      style: "myCellSmall",
                      text: "สี " + car_sell.car_color_name,
                    },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                },
                "",
                { text: "", style: "myCellPrice" },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    { width: "25%", text: "เลขตัวถัง", style: "myCellSmall" },
                    {
                      width: "75%",
                      style: "myCellSmall",
                      text: car_sell.car_number.toUpperCase(),
                    },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                },
                "",
                { text: "", style: "myCellPrice" },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    {
                      width: "25%",
                      text: "เลขเครื่องยนต์",
                      style: "myCellSmall",
                    },
                    {
                      width: "75%",
                      style: "myCellSmall",
                      text: car_sell.car_num_engines.toUpperCase(),
                    },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                },
                "",
                { text: "", style: "myCellPrice" },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    { width: "25%", text: "ทะเบียน", style: "myCellSmall" },
                    { width: "75%", style: "myCellSmall", text: car_license },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                },
                "",
                { text: "", style: "myCellPrice" },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, true],
                },
                {
                  columns: [
                    {
                      width: "25%",
                      text: port === 9039 ? " " : "ผู้ซื้อ",
                      style: port === 9039 ? "myCellSmallWhite" : "myCellSmall",
                    },
                    {
                      width: "75%",
                      style: "myCellSmall",
                      text:
                        port === 9039
                          ? ""
                          : car_sell.customer_name +
                            " " +
                            car_sell.customer_lastname,
                    },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                },
                "",
                { text: "", style: "myCellPrice" },
              ],
              /*[
                 {text: '', style: 'myCellDetail'},
                 {
                   columns: [
                     { width: '35%',
                       text: '\n', style: 'normal',
                     },
                     { width: '65%', style: 'normal',
                       text: '',
                     },
                   ],
                   columnGap: 0,
                   lineHeight:1,
                    colSpan: 2,
                 },
                 '',
                 {text: '', style: 'myCellPrice'}
               ],*/
              /*[
                 {text: '', style: 'myCellDetail'},
                 {
                   columns: [
                     { width: '35%',
                       text: '\n', style: 'normal',
                     },
                     { width: '65%', style: 'normal',
                       text: '',
                     },
                   ],
                   columnGap: 0,
                   lineHeight:1,
                    colSpan: 2,
                 },
                 '',
                 {text: '', style: 'myCellPrice'}
               ],*/
              [
                {
                  text: "",
                  style: "myCellBold",
                  colSpan: 2,
                  border: [true, false, true, false],
                },
                "",
                { text: "รวมเป็นเงิน", style: "smallRightBold" },
                {
                  text: NumberUtil.addCommas(String(tax_invoice_amount)),
                  style: "myCellPrice",
                },
              ],
              [
                {
                  text: "(" + tax_invoice_total_text + ")",
                  style: "smallCenterBold",
                  colSpan: 2,
                  border: [true, false, false, false],
                },
                "",
                {
                  text: "ภาษีมูลค่าเพิ่ม " + vatPercentText + "%",
                  style: "smallRightBold",
                  border: [true, true, true, true],
                },
                {
                  text: NumberUtil.addCommas(
                    tax_invoice_vat.toFixed(2).toString()
                  ),
                  style: "myCellPrice",
                },
              ],
              [
                {
                  text: "(ตัวอักษร)",
                  style: "smallCenterBold",
                  colSpan: 2,
                  border: [true, false, false, true],
                },
                "",
                {
                  text: "จำนวนเงินรวมทั้งสิ้น",
                  style: "smallRightBold",
                  border: [true, true, true, true],
                },
                {
                  text: NumberUtil.addCommas(
                    tax_invoice_total.toFixed(2).toString()
                  ),
                  style: "myCellPrice",
                },
              ],
              [
                {
                  text: "\n",
                  style: "normalCenter",
                  colSpan: 4,
                  border: [false, false, false, false],
                },
                "",
                "",
                "",
              ],
              [
                {
                  text: "\n",
                  style: "normalCenter",
                  colSpan: 4,
                  border: [false, false, false, false],
                },
                "",
                "",
                "",
              ],
              /* [
                {text: '\n', style: 'normalCenter', colSpan: 4, border: [false, false, false, false],},
                '',
                '',
                ''
              ],*/
              /*[
                {text: '', style: 'normal', colSpan: 4, border: [false, false, false, false],},
                '',
                '',
                ''
              ],*/
            ],
          },
          columnGap: 0,
        },
        /*{
          columns: [
            {
              width: '40%',
              text: 'ลงชื่อ...............................................ผู้รับเงิน',
              style: 'normalCenter',
            },
            {
              width: '60%', style: 'normal', text: '',
            },
          ],
          columnGap: 0,
          lineHeight:1,

        },*/
        {
          table: {
            widths: ["45%", "5%", "45%"],
            body: [
              [
                {
                  text: "ลงชื่อ.....................................................ผู้จ่ายเงิน",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 25, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 25, 0, 0],
                },
                {
                  text: "ลงชื่อ.....................................................ผู้รับเงิน",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 25, 0, 0],
                },
              ],
              [
                {
                  text: "(.........................................................) ",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-12, 2, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 2, 0, 0],
                },
                {
                  text: taxInvoicePayee,
                  border: [false, false, false, false],
                  margin: [-6, 2, 0, 0],
                },
              ],
              [
                {
                  text: "วันที่ ........................................................",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-22, 2, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 2, 0, 0],
                },
                {
                  text: "วันที่ ........................................................",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-16, 2, 0, 0],
                },
              ],
            ],
          },
        },
      ],
      images: {
        emptySeal:
          "data:image/png;base64,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",
      },
      styles: {
        normal: {
          fontSize: 16,
        },
        normalNo: {
          fontSize: 16,
          bold: true,
        },
        normalCenter: {
          fontSize: 16,
          alignment: "center",
        },
        normalRight: {
          fontSize: 16,
          alignment: "right",
        },
        normalRightBold: {
          fontSize: 16,
          alignment: "right",
          bold: true,
        },
        textBold: {
          fontSize: 16,
          bold: true,
        },
        textBoldCenter: {
          fontSize: 16,
          bold: true,
          alignment: "center",
        },
        textBoldHead: {
          fontSize: 16,
          bold: true,
          alignment: "left",
        },
        smallCenter: {
          fontSize: 14,
          alignment: "center",
        },
        smallCenterBold: {
          fontSize: 14,
          alignment: "center",
          bold: true,
        },
        smallRightBold: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: "center",
        },
        body: {
          fontSize: 14,
        },
        bodycompany: {
          fontSize: 14,
          bold: true,
        },
        anotherStyle: {
          italic: true,
        },
        myCell: {
          fontSize: 16,
          // fillColor: '#BEBEBE',
          alignment: "center",
          // bold: true,
        },
        myCellBold: {
          fontSize: 14,
          // fillColor: '#BEBEBE',
          alignment: "center",
          bold: true,
        },
        myCellSmall: {
          fontSize: 14,
        },
        myCellSmallWhite: {
          fontColor: "#ffffff",
          fontSize: 14,
        },
        myCellDetail: {
          fontSize: 14,
          alignment: "center",
        },
        myCellPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumText: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "left",
          bold: true,
        },
        myCellSumCost: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "right",
          bold: true,
        },
        myCellSumTextCost: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "left",
          bold: true,
        },
        myCellSumTextCostNum: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "right",
          bold: true,
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };
    pdfMake.createPdf(docDefinition).open();
  }

  // 9043 ATCar เส้นตารางรายการ / จำนวนเงินไม่ต้องแสดง
  printTaxInvoiceNoLine(isCopy) {
    const {
      company_setting,
      date_receive_thai,
      carBase64Img,
      sealBase64Img,
      tax_invoice_name,
      tax_invoice_address1,
      tax_invoice_address2,
      tax_invoice_tax_id,
      tax_invoice_total,
      tax_invoice_vat,
      tax_invoice_payee,
      use_old_license,
      car_sell,
    } = this.state;
    // let moneyText = ThaiBaht(car_sell_pay.car_sell_pay_count)
    let car_brand_name = car_sell.car_brand_name;
    let car_model_name = car_sell.car_model_name;
    let car_sub_model_name = car_sell.car_sub_model_name;

    let car_name2 =
      car_brand_name + " " + car_model_name + " " + car_sub_model_name;

    if (car_sub_model_name.indexOf(car_model_name) !== -1) {
      // มีชื่อรุ่นใน รุ่นย่อย
      car_name2 = car_brand_name + " " + car_sub_model_name;
    } else if (car_model_name.indexOf(car_brand_name) !== -1) {
      car_name2 = car_model_name + " " + car_sub_model_name;
    }

    let taxInvoicePayee;
    if (tax_invoice_payee === null || tax_invoice_payee === "") {
      taxInvoicePayee = [
        {
          text: "(.........................................................)",
          style: "smallCenter",
        },
      ];
    } else {
      taxInvoicePayee = [
        { text: "( " + tax_invoice_payee + " )", style: "smallCenter" },
      ];
    }

    let company_name = company_setting.company_name;
    let company_address = company_setting.company_address;
    let juristic_number = company_setting.juristic_number;
    let company_tel =
      company_setting.company_tel === "" ? "-" : company_setting.company_tel;
    let doc_type = isCopy ? "( สำเนา )" : "( ต้นฉบับ )";

    let tax_invoice_total_text = ThaiBaht(tax_invoice_total);
    let tax_invoice_amount = parseFloat(
      Number(this.state.tax_invoice_amount)
    ).toFixed(2);
    let tax_invoice_no = this.state.tax_invoice_no;
    let tax_invoice_number =
      this.state.tax_invoice_number === null
        ? "-"
        : this.state.tax_invoice_number;

    let head_line3 =
      "โทร. " + company_tel + " เลขประจำตัวผู้เสียภาษี " + juristic_number;

    let invoiceNoRow;
    if (
      tax_invoice_no === null ||
      tax_invoice_no === "" ||
      tax_invoice_no === "-"
    ) {
      invoiceNoRow = [
        { text: "", style: "normalNo", margin: [0, 15, 0, 0] },
        {
          text: "เลขที่ " + tax_invoice_number,
          style: "normalRightBold",
          colSpan: 2,
          margin: [0, 15, 0, 0],
        },
        "",
      ];
    } else {
      // {text: '', style: 'normalCenter'},
      invoiceNoRow = [
        {
          text: "เล่มที่ " + tax_invoice_no,
          style: "normalNo",
          margin: [0, 15, 0, 0],
        },
        {
          text: "เลขที่ " + tax_invoice_number,
          style: "normalRightBold",
          colSpan: 2,
          margin: [0, 15, 0, 0],
        },
        "",
      ];
    }

    let vatPercentText =
      this.state.company_setting === null
        ? "-"
        : String(this.state.company_setting.vat);

    let headerLeft;
    let headerCenter;
    if (Number(port) === 9008) {
      // roddee
      headerLeft = { text: "", style: "normal" };
      // headerLeft = {
      //   image: sealBase64Img, width: 100
      // }
      headerCenter =
        company_name +
        "\n" +
        company_address +
        "\n" +
        "เลขประจำตัวผู้เสียภาษี " +
        juristic_number;
    } else {
      let logo_width = 110;
      if (company_address.length >= 60 || head_line3.length >= 60) {
        logo_width = 100;
      } else if (company_address.length >= 57 || head_line3.length >= 57) {
        logo_width = 96;
      }

      if (port === 9000) {
        logo_width = 80;
      }

      headerLeft = {
        image: carBase64Img,
        width: logo_width,
      };
      headerCenter = company_name + "\n" + company_address + "\n" + head_line3;
    }

    let imageEmptySeal = {
      image: "emptySeal",
      width: 100,
      border: [false, false, false, false],
      rowSpan: 3,
    };

    let car_license_new =
      car_sell.car_license_plate_new + " " + car_sell.province_name_new;
    let car_license_old =
      car_sell.car_license_plate_old + " " + car_sell.province_name_old;
    let car_license = use_old_license === 1 ? car_license_old : car_license_new;

    let carName;
    carName = [
      { text: "1", style: "myCellDetail", border: [true, false, false, false] },
      {
        columns: [
          { width: "25%", text: "ค่ารถยนต์", style: "myCellSmall" },
          { width: "75%", style: "myCellSmall", text: car_name2 },
        ],
        columnGap: 0,
        lineHeight: 1,
        colSpan: 2,
        border: [true, false, true, false],
      },
      "",
      {
        text: NumberUtil.addCommas(String(tax_invoice_amount)),
        style: "myCellPrice",
        border: [false, false, true, false],
      },
    ];

    // pageMargins : [left, top, right, bottom]
    let docDefinition = {
      pageOrientation: "portrait",
      pageSize: "A4",
      pageMargins: [40, 35, 40, 0],
      // background: {image: 'book', width: 600},
      content: [
        {
          table: {
            widths: ["15%", "70%", "15%"],
            body: [
              [
                headerLeft,
                {
                  text: headerCenter,
                  style: "textBoldHead",
                  margin: [50, 4, 0, 0],
                  colSpan: 2,
                },
                { text: "", style: "normal" },
              ],
              [
                { text: "", style: "normalCenter" },
                {
                  text: "ใบเสร็จรับเงิน / ใบกำกับภาษี",
                  style: "textBoldCenter",
                  margin: [0, 25, 0, 0],
                },
                { text: "", style: "normalRight" },
              ],
              [
                { text: " ", style: "normalCenter" },
                { text: doc_type, style: "normalCenter" },
                { text: " ", style: "normalRight" },
              ],
              invoiceNoRow,
              // [
              //   {text: ' ' , style: 'normalCenter'},
              //   {text: '', style: 'normalCenter'},
              //   {text: ' ', style: 'normalRight'},
              // ],
              [
                { text: " ", style: "normalCenter" },
                {
                  text: "วันที่ " + date_receive_thai,
                  style: "normalRight",
                  colSpan: 2,
                },
                "",
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          columns: [
            { width: "15%", text: "นามลูกค้า", style: "textBold" },
            { width: "85%", style: "normal", text: tax_invoice_name },
          ],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          columns: [
            { width: "15%", text: "ที่อยู่", style: "textBold" },
            { width: "85%", style: "normal", text: tax_invoice_address1 },
          ],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          columns: [
            { width: "15%", text: "", style: "normal" },
            { width: "85%", style: "normal", text: tax_invoice_address2 },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 0, 0, 0],
        },
        {
          columns: [
            { width: "15%", text: "", style: "normal" },
            {
              width: "85%",
              style: "normal",
              text: "เลขประจำตัวผู้เสียภาษี " + tax_invoice_tax_id,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 0, 0, 20],
        },
        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: ["14%", "48%", "22%", "16%"],
            // heights: [20, 30],
            body: [
              [
                { text: "จำนวน", style: "myCellBold" },
                { text: "รายการ", style: "myCellBold", colSpan: 2 },
                "",
                { text: "จำนวนเงิน", style: "myCellBold" },
              ],
              carName,
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    {
                      width: "25%",
                      text: "ปี " + car_sell.car_year_name,
                      style: "myCellSmall",
                    },
                    {
                      width: "75%",
                      style: "myCellSmall",
                      text: "สี " + car_sell.car_color_name,
                    },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                  border: [true, false, true, false],
                },
                "",
                {
                  text: "",
                  style: "myCellPrice",
                  border: [false, false, true, false],
                },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    { width: "25%", text: "เลขตัวถัง", style: "myCellSmall" },
                    {
                      width: "75%",
                      style: "myCellSmall",
                      text: car_sell.car_number.toUpperCase(),
                    },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                  border: [true, false, true, false],
                },
                "",
                {
                  text: "",
                  style: "myCellPrice",
                  border: [false, false, true, false],
                },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    {
                      width: "25%",
                      text: "เลขเครื่องยนต์",
                      style: "myCellSmall",
                    },
                    {
                      width: "75%",
                      style: "myCellSmall",
                      text: car_sell.car_num_engines.toUpperCase(),
                    },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                  border: [true, false, true, false],
                },
                "",
                {
                  text: "",
                  style: "myCellPrice",
                  border: [false, false, true, false],
                },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    { width: "25%", text: "ทะเบียน", style: "myCellSmall" },
                    { width: "75%", style: "myCellSmall", text: car_license },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                  border: [true, false, true, false],
                },
                "",
                {
                  text: "",
                  style: "myCellPrice",
                  border: [false, false, true, false],
                },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, true],
                },
                {
                  columns: [
                    { width: "25%", text: "ผู้ซื้อ", style: "myCellSmall" },
                    {
                      width: "75%",
                      style: "myCellSmall",
                      text:
                        car_sell.customer_name +
                        " " +
                        car_sell.customer_lastname,
                    },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                  border: [true, false, true, true],
                },
                "",
                {
                  text: "",
                  style: "myCellPrice",
                  border: [false, false, true, false],
                },
              ],

              [
                {
                  text: "",
                  style: "myCellBold",
                  colSpan: 2,
                  border: [true, false, true, false],
                },
                "",
                { text: "รวมเป็นเงิน", style: "smallRightBold" },
                {
                  text: NumberUtil.addCommas(String(tax_invoice_amount)),
                  style: "myCellPrice",
                },
              ],
              [
                {
                  text: "(" + tax_invoice_total_text + ")",
                  style: "smallCenterBold",
                  colSpan: 2,
                  border: [true, false, false, false],
                },
                "",
                {
                  text: "ภาษีมูลค่าเพิ่ม " + vatPercentText + "%",
                  style: "smallRightBold",
                  border: [true, true, true, true],
                },
                {
                  text: NumberUtil.addCommas(
                    tax_invoice_vat.toFixed(2).toString()
                  ),
                  style: "myCellPrice",
                },
              ],
              [
                {
                  text: "(ตัวอักษร)",
                  style: "smallCenterBold",
                  colSpan: 2,
                  border: [true, false, false, true],
                },
                "",
                {
                  text: "จำนวนเงินรวมทั้งสิ้น",
                  style: "smallRightBold",
                  border: [true, true, true, true],
                },
                {
                  text: NumberUtil.addCommas(
                    tax_invoice_total.toFixed(2).toString()
                  ),
                  style: "myCellPrice",
                },
              ],
              [
                {
                  text: "\n",
                  style: "normalCenter",
                  colSpan: 4,
                  border: [false, false, false, false],
                },
                "",
                "",
                "",
              ],
              [
                {
                  text: "\n",
                  style: "normalCenter",
                  colSpan: 4,
                  border: [false, false, false, false],
                },
                "",
                "",
                "",
              ],
            ],
          },
          columnGap: 0,
        },
        {
          table: {
            widths: ["45%", "5%", "45%"],
            body: [
              [
                {
                  text: "ลงชื่อ.....................................................ผู้จ่ายเงิน",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 25, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 25, 0, 0],
                },
                {
                  text: "ลงชื่อ.....................................................ผู้รับเงิน",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 25, 0, 0],
                },
              ],
              [
                {
                  text: "(.........................................................) ",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-12, 2, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 2, 0, 0],
                },
                {
                  text: taxInvoicePayee,
                  border: [false, false, false, false],
                  margin: [-6, 2, 0, 0],
                },
              ],
              [
                {
                  text: "วันที่ ........................................................",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-22, 2, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 2, 0, 0],
                },
                {
                  text: "วันที่ ........................................................",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-16, 2, 0, 0],
                },
              ],
            ],
          },
        },
      ],
      images: {
        emptySeal:
          "data:image/png;base64,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",
      },
      styles: {
        normal: {
          fontSize: 16,
        },
        normalNo: {
          fontSize: 16,
          bold: true,
        },
        normalCenter: {
          fontSize: 16,
          alignment: "center",
        },
        normalRight: {
          fontSize: 16,
          alignment: "right",
        },
        normalRightBold: {
          fontSize: 16,
          alignment: "right",
          bold: true,
        },
        textBold: {
          fontSize: 16,
          bold: true,
        },
        textBoldCenter: {
          fontSize: 16,
          bold: true,
          alignment: "center",
        },
        textBoldHead: {
          fontSize: 16,
          bold: true,
          alignment: "left",
        },
        smallCenter: {
          fontSize: 14,
          alignment: "center",
        },
        smallCenterBold: {
          fontSize: 14,
          alignment: "center",
          bold: true,
        },
        smallRightBold: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: "center",
        },
        body: {
          fontSize: 14,
        },
        bodycompany: {
          fontSize: 14,
          bold: true,
        },
        anotherStyle: {
          italic: true,
        },
        myCell: {
          fontSize: 16,
          // fillColor: '#BEBEBE',
          alignment: "center",
          // bold: true,
        },
        myCellBold: {
          fontSize: 14,
          // fillColor: '#BEBEBE',
          alignment: "center",
          bold: true,
        },
        myCellSmall: {
          fontSize: 14,
        },
        myCellSmallWhite: {
          fontColor: "#ffffff",
          fontSize: 14,
        },
        myCellDetail: {
          fontSize: 14,
          alignment: "center",
        },
        myCellPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumText: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "left",
          bold: true,
        },
        myCellSumCost: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "right",
          bold: true,
        },
        myCellSumTextCost: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "left",
          bold: true,
        },
        myCellSumTextCostNum: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "right",
          bold: true,
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };
    pdfMake.createPdf(docDefinition).open();
  }

  printTaxInvoice2(isCopy) {
    //ber1rodbann
    const {
      company_setting,
      date_receive_thai,
      carBase64Img,
      sealBase64Img,
      tax_invoice_name,
      tax_invoice_address1,
      tax_invoice_address2,
      tax_invoice_tax_id,
      tax_invoice_total,
      tax_invoice_vat,
      tax_invoice_payee,
      car_sell,
      gearbox_warranty,
      use_old_license,
    } = this.state;
    // let moneyText = ThaiBaht(car_sell_pay.car_sell_pay_count)

    let company_name = company_setting.company_name;
    let company_address = company_setting.company_address;
    let juristic_number = company_setting.juristic_number;
    let company_tel =
      company_setting.company_tel === "" ? "-" : company_setting.company_tel;
    let doc_type = isCopy ? "( สำเนา )" : "( ต้นฉบับ )";

    let tax_invoice_total_text = ThaiBaht(tax_invoice_total);
    let tax_invoice_amount = parseFloat(
      Number(this.state.tax_invoice_amount)
    ).toFixed(2);
    let tax_invoice_no = this.state.tax_invoice_no;
    let tax_invoice_number =
      this.state.tax_invoice_number === null
        ? "-"
        : this.state.tax_invoice_number;

    let head_line3 =
      "โทร. " + company_tel + " เลขประจำตัวผู้เสียภาษี " + juristic_number;

    let gearbox_amount = parseFloat(Number(this.state.gearbox_amount));
    let debt_insurance_amount = parseFloat(
      Number(this.state.debt_insurance_amount)
    );

    let invoiceNoRow;
    if (
      tax_invoice_no === null ||
      tax_invoice_no === "" ||
      tax_invoice_no === "-"
    ) {
      invoiceNoRow = [
        { text: "", style: "normal" },
        {
          text: "เลขที่ " + tax_invoice_number,
          style: "normalRight",
          colSpan: 2,
          marginTop: 10,
        },
        "",
      ];
    } else {
      // {text: '', style: 'normalCenter'},
      invoiceNoRow = [
        { text: "เล่มที่ " + tax_invoice_no, style: "normal" },
        {
          text: "เลขที่ " + tax_invoice_number,
          style: "normalRight",
          colSpan: 2,
          marginTop: 10,
        },
        "",
      ];
    }

    let vatPercentText =
      this.state.company_setting === null
        ? "-"
        : String(this.state.company_setting.vat);

    let headerLeft;
    let headerCenter;

    let logo_width = 110;
    if (company_address.length >= 60 || head_line3.length >= 60) {
      logo_width = 100;
    } else if (company_address.length >= 57 || head_line3.length >= 57) {
      logo_width = 96;
    }

    headerLeft = {
      image: carBase64Img,
      width: logo_width,
    };
    // headerCenter = company_name+'\n'+company_address+'\nโทร. '+company_tel+'  เลขประจำตัวผู้เสียภาษี '+juristic_number
    headerCenter = company_name + "\n" + company_address + "\n" + head_line3;

    let imageEmptySeal = {
      /*image: 'emptySeal',
      width: 100,
      border: [false, false, false, false],
      rowSpan: 3*/
    };

    let car_license_new =
      car_sell.car_license_plate_new + " " + car_sell.province_name_new;
    let car_license_old =
      car_sell.car_license_plate_old + " " + car_sell.province_name_old;
    let car_license = use_old_license === 1 ? car_license_old : car_license_new;

    let car_brand_name = car_sell.car_brand_name;
    let car_model_name = car_sell.car_model_name;
    let car_sub_model_name = car_sell.car_sub_model_name;

    let car_name2 =
      car_brand_name + " " + car_model_name + " " + car_sub_model_name;

    if (car_sub_model_name.indexOf(car_model_name) !== -1) {
      // มีชื่อรุ่นใน รุ่นย่อย
      car_name2 = car_brand_name + " " + car_sub_model_name;
    }

    let rowOptions = [
      [
        { text: "จำนวน", style: "myCellBold" },
        { text: "รายการ", style: "myCellBold", colSpan: 3 },
        "",
        "",
        { text: "จำนวนเงิน", style: "myCellBold" },
      ],
      [
        {
          text: "1",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            { width: "25%", text: "ค่ารถยนต์", style: "myCellSmall" },
            { width: "75%", style: "myCellSmall", text: car_name2 },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 3,
          border: [true, false, true, false],
        },
        "",
        "",
        {
          text: NumberUtil.addCommas(
            String(tax_invoice_amount - gearbox_amount - debt_insurance_amount)
          ),
          style: "myCellPrice",
          border: [false, false, true, false],
        },
      ],
      [
        {
          text: "",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            { width: "25%", text: "ทะเบียน", style: "myCellSmall" },
            { width: "75%", style: "myCellSmall", text: car_license },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 3,
          border: [true, false, true, false],
        },
        "",
        "",
        { text: "", style: "myCellPrice", border: [false, false, true, false] },
      ],
      [
        {
          text: "",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            {
              width: "25%",
              text: "ปี " + car_sell.car_year_name,
              style: "myCellSmall",
            },
            {
              width: "75%",
              style: "myCellSmall",
              text: "สี " + car_sell.car_color_name,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 3,
          border: [true, false, true, false],
        },
        "",
        "",
        { text: "", style: "myCellPrice", border: [false, false, true, false] },
      ],
      [
        {
          text: "",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            { width: "25%", text: "เลขตัวถัง", style: "myCellSmall" },
            {
              width: "75%",
              style: "myCellSmall",
              text: car_sell.car_number.toUpperCase(),
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 3,
          border: [true, false, true, false],
        },
        "",
        "",
        { text: "", style: "myCellPrice", border: [false, false, true, false] },
      ],
      [
        {
          text: "",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            { width: "25%", text: "เลขเครื่องยนต์", style: "myCellSmall" },
            {
              width: "75%",
              style: "myCellSmall",
              text: car_sell.car_num_engines.toUpperCase(),
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 3,
          border: [true, false, true, false],
        },
        "",
        "",
        { text: "", style: "myCellPrice", border: [false, false, true, false] },
      ],
    ];

    /*let rowGearbox = [
      {text: '', style: 'myCellDetail'},
      {text: '', style: 'myCellDetail'},
        '',
      {text: '', style: 'myCellDetail'},
    ]*/
    if (gearbox_amount > 0) {
      let rowGearbox = [
        {
          text: "",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            { width: "25%", text: "ประกันเครื่องเกียร์", style: "myCellSmall" },
            { width: "75%", style: "myCellSmall", text: "" },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 3,
          border: [true, false, true, false],
        },
        "",
        "",
        {
          text: NumberUtil.addCommas(String(gearbox_amount)),
          style: "myCellPrice",
          border: [false, false, true, false],
        },
      ];
      rowOptions.push(rowGearbox);
    }

    if (debt_insurance_amount > 0) {
      let rowDebt = [
        {
          text: "",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            { width: "25%", text: "ประกันภาระหนี้", style: "myCellSmall" },
            { width: "75%", style: "myCellSmall", text: " " },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 3,
          border: [true, false, true, false],
        },
        "",
        "",
        {
          text: NumberUtil.addCommas(String(debt_insurance_amount)),
          style: "myCellPrice",
          border: [false, false, true, false],
        },
      ];
      rowOptions.push(rowDebt);
    }

    let rowBuyer = [
      { text: "", style: "myCellDetail", border: [true, false, false, true] },
      {
        columns: [
          { width: "25%", text: "ผู้ซื้อ", style: "myCellSmall" },
          {
            width: "75%",
            style: "myCellSmall",
            text: car_sell.customer_name + " " + car_sell.customer_lastname,
          },
        ],
        columnGap: 0,
        lineHeight: 1,
        colSpan: 3,
        border: [true, false, true, true],
      },
      "",
      "",
      { text: "", style: "myCellPrice", border: [false, false, true, false] },
    ];

    if (port !== 9039) {
      rowOptions.push(rowBuyer);
    }

    let rowSumAll = [
      {
        text: "",
        style: "myCellBold",
        colSpan: 3,
        border: [true, false, true, false],
      },
      "",
      "",
      { text: "รวมราคาทั้งสิ้น", style: "smallRightBold" },
      {
        text: NumberUtil.addCommas(String(tax_invoice_amount)),
        style: "myCellPrice",
      },
    ];

    let rowVat = [
      {
        text: "(" + tax_invoice_total_text + ")",
        style: "smallCenterBold",
        colSpan: 3,
        border: [true, false, false, false],
      },
      "",
      "",
      {
        text: "ภาษีมูลค่าเพิ่ม " + vatPercentText + "%",
        style: "smallRightBold",
        border: [true, true, true, true],
      },
      {
        text: NumberUtil.addCommas(tax_invoice_vat.toFixed(2).toString()),
        style: "myCellPrice",
      },
    ];

    let rowTotal = [
      {
        text: "จำนวนเงินทั้งสิ้น ( ตัวอักษร )",
        style: "smallCenterBold",
        colSpan: 3,
        border: [true, false, false, true],
      },
      "",
      "",
      {
        text: "จำนวนรวมเงินทั้งสิ้น",
        style: "smallRightBold",
        border: [true, true, true, true],
      },
      {
        text: NumberUtil.addCommas(tax_invoice_total.toFixed(2).toString()),
        style: "myCellPrice",
      },
    ];

    let rowNamePosition = [
      {
        text: "ฝ่ายบัญชี/การเงิน",
        style: "smallCenter",
        border: [true, false, true, false],
        colSpan: 2,
        margin: [0, 7, 0, 0],
      },
      "",
      {
        text: "ผู้รับเงิน",
        style: "smallCenter",
        border: [true, false, true, false],
        margin: [0, 7, 0, 0],
      },
      {
        text: "ในนาม " + company_name,
        style: "smallCenter",
        border: [true, false, true, false],
        colSpan: 2,
        margin: [0, 7, 0, 0],
      },
      "",
    ];

    let rowNamePositionEmpty01 = [
      {
        text: "\n",
        style: "smallCenter",
        border: [true, false, true, false],
        colSpan: 2,
      },
      "",
      { text: "\n", style: "smallCenter", border: [true, false, true, false] },
      {
        text: "\n",
        style: "smallCenter",
        border: [true, false, true, false],
        colSpan: 2,
      },
      "",
    ];

    let rowNamePositionEmpty02 = [
      {
        text: "\n",
        style: "smallCenter",
        border: [true, false, true, false],
        colSpan: 2,
      },
      "",
      { text: "\n", style: "smallCenter", border: [true, false, true, false] },
      {
        text: "\n",
        style: "smallCenter",
        border: [true, false, true, false],
        colSpan: 2,
      },
      "",
    ];

    let rowNamePositionDate = [
      {
        text: "วันที่................................................",
        style: "smallCenter",
        border: [true, true, true, true],
        colSpan: 2,
      },
      "",
      {
        text: "วันที่................................................",
        style: "smallCenter",
        border: [true, true, true, true],
      },
      {
        text: "ผู้มีอำนาจลงนาม",
        style: "smallCenter",
        border: [true, true, true, true],
        colSpan: 2,
      },
      "",
    ];

    let rowEmpty = [
      {
        text: "\n",
        style: "normalCenter",
        colSpan: 5,
        border: [false, false, false, false],
      },
      "",
      "",
      "",
      "",
    ];

    rowOptions.push(rowSumAll);
    rowOptions.push(rowVat);
    rowOptions.push(rowTotal);
    rowOptions.push(rowNamePosition);
    rowOptions.push(rowNamePositionEmpty01);
    rowOptions.push(rowNamePositionEmpty02);
    rowOptions.push(rowNamePositionDate);
    rowOptions.push(rowEmpty);

    // pageMargins : [left, top, right, bottom]
    let docDefinition = {
      pageOrientation: "portrait",
      pageSize: "A4",
      pageMargins: [55, 30, 55, 0],
      // background: {image: 'book', width: 600},
      content: [
        {
          table: {
            widths: ["15%", "70%", "15%"],
            body: [
              [
                headerLeft,
                {
                  text: headerCenter,
                  style: "textBold",
                  colSpan: 2,
                  margin: [70, 4, 0, 0],
                },
                "",
              ],
              invoiceNoRow,
              [
                { text: "", style: "normalCenter" },
                {
                  text: "ใบเสร็จรับเงิน / ใบกำกับภาษี",
                  style: "textBoldCenter",
                },
                { text: "", style: "normalRight" },
              ],
              [
                { text: " ", style: "normalCenter" },
                { text: doc_type, style: "normalCenter" },
                { text: " ", style: "normalRight" },
              ],
              [
                { text: " ", style: "normalCenter" },
                {
                  text: "วันที่ " + date_receive_thai,
                  style: "normalRight",
                  colSpan: 2,
                },
                "",
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          columns: [
            { width: "15%", text: "นามลูกค้า", style: "textBold" },
            { width: "85%", style: "normal", text: tax_invoice_name },
          ],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          columns: [
            { width: "15%", text: "ที่อยู่", style: "textBold" },
            { width: "85%", style: "normal", text: tax_invoice_address1 },
          ],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          columns: [
            { width: "15%", text: "", style: "normal" },
            { width: "85%", style: "normal", text: tax_invoice_address2 },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 0, 0, 0],
        },
        {
          columns: [
            { width: "15%", text: "", style: "normal" },
            {
              width: "85%",
              style: "normal",
              text: "เลขประจำตัวผู้เสียภาษี " + tax_invoice_tax_id,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 0, 0, 20],
        },
        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            // 14	17	31	22	16
            headerRows: 1,
            widths: ["14%", "17%", "31%", "22%", "16%"],
            // heights: [20, 30],
            body: rowOptions,
          },
          columnGap: 0,
        },
        /*{
          table: {
            widths: [ '25%', '15%', '15%', '45%' ],
            body: [
              [
                {text: ' ชำระโดย ', style: 'body', border: [false, false, false, false]},
                {
                  columns: [
                    {
                      svg: '<svg width="12" height="12">' +
                          '  <rect x="1" y="2" width="10" height="10" style="fill:white;stroke:black;stroke-width:1;opacity:1" />\n' +
                          '  ............ ' +
                          '</svg>',
                      width: 12,
                    },
                    { width: '85%', style: 'body',
                      text: 'เงินสด',
                    },
                  ],
                  columnGap: 6,
                  lineHeight:1,
                  border: [false, false, false, false]
                },
                {
                  columns: [
                    {
                      svg: '<svg width="12" height="12">' +
                          '  <rect x="1" y="2" width="10" height="10" style="fill:white;stroke:black;stroke-width:1;opacity:1" />\n' +
                          '  ............ ' +
                          '</svg>',
                      width: 12,
                    },
                    { width: '85%', style: 'body',
                      text: 'เงินโอน',
                    },
                  ],
                  columnGap: 6,
                  lineHeight:1,
                  border: [false, false, false, false]
                },
                {
                  columns: [
                    {
                      svg: '<svg width="12" height="12">' +
                          '  <rect x="1" y="2" width="10" height="10" style="fill:white;stroke:black;stroke-width:1;opacity:1" />\n' +
                          '  ............ ' +
                          '</svg>',
                      width: 12,
                    },
                    { width: '85%', style: 'body',
                      text: 'เช็ค',
                    },
                  ],
                  columnGap: 6,
                  lineHeight:1,
                  border: [false, false, false, false]
                },
              ],
            ]
          }
        },*/
        /*{
          table: {
            widths: [ '36%', '36%', '36%' ],
            body: [
              [
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
              ],
              [
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
              ],
              [
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
              ],
              [
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
              ],
              [
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
              ],
              [
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
                {text: '', style: 'smallCenter', border: [false, false, false, false]},
              ],
              [
                {text: 'ลงชื่อ.........................................ผู้รับเงิน', style: 'smallCenter', border: [false, false, false, false]},
                {text: 'ลงชื่อ.........................................ผู้รับเงิน', style: 'smallCenter', border: [false, false, false, false]},
                {text: 'ลงชื่อ.........................................ผู้รับสินค้า', style: 'smallCenter', border: [false, false, false, false]},
              ],
              [
                {text: '( '+ tax_invoice_payee +' )', style: 'smallCenter', border: [false, false, false, false]},
                {text: ' (.........................................) ', style: 'smallCenter', border: [false, false, false, false]},
                {text: ' (.........................................) ', style: 'smallCenter', border: [false, false, false, false]},
              ],
              [
                {text: ' ผู้อนุมัติ ', style: 'smallCenter', border: [false, false, false, false]},
                {text: ' ผู้อนุมัติ ', style: 'smallCenter', border: [false, false, false, false]},
                {text: ' '+ tax_invoice_name +' ', style: 'smallCenter', border: [false, false, false, false]},
              ],
            ]
          }
        },*/
      ],
      images: {
        emptySeal:
          "data:image/png;base64,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",
      },
      styles: {
        normal: {
          fontSize: 16,
        },
        normalCenter: {
          fontSize: 16,
          alignment: "center",
        },
        normalRight: {
          fontSize: 16,
          alignment: "right",
        },
        textBold: {
          fontSize: 16,
          bold: true,
        },
        textBoldCenter: {
          fontSize: 16,
          bold: true,
          alignment: "center",
        },
        smallCenter: {
          fontSize: 14,
          alignment: "center",
        },
        smallCenterBold: {
          fontSize: 14,
          alignment: "center",
          bold: true,
        },
        smallRightBold: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: "center",
        },
        body: {
          fontSize: 14,
        },
        bodycompany: {
          fontSize: 14,
          bold: true,
        },
        anotherStyle: {
          italic: true,
        },
        myCell: {
          fontSize: 16,
          // fillColor: '#BEBEBE',
          alignment: "center",
          // bold: true,
        },
        myCellBold: {
          fontSize: 14,
          // fillColor: '#BEBEBE',
          alignment: "center",
          bold: true,
        },
        myCellSmall: {
          fontSize: 14,
        },
        myCellDetail: {
          fontSize: 14,
          alignment: "center",
        },
        myCellPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumText: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "left",
          bold: true,
        },
        myCellSumCost: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "right",
          bold: true,
        },
        myCellSumTextCost: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "left",
          bold: true,
        },
        myCellSumTextCostNum: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "right",
          bold: true,
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };
    pdfMake.createPdf(docDefinition).open();
  }

  printTaxInvoiceCodeItem(isCopy) {
    //kmhomecar //thadyonauto
    const {
      company_setting,
      date_receive_thai,
      carBase64Img,
      sealBase64Img,
      tax_invoice_name,
      tax_invoice_address1,
      tax_invoice_address2,
      tax_invoice_tax_id,
      tax_invoice_total,
      tax_invoice_vat,
      tax_invoice_payee,
      car_sell,
      gearbox_warranty,
      use_old_license,
    } = this.state;
    // let moneyText = ThaiBaht(car_sell_pay.car_sell_pay_count)

    let company_name = company_setting.company_name;
    let company_address = company_setting.company_address;
    let juristic_number = company_setting.juristic_number;
    let company_tel =
      company_setting.company_tel === "" ? "-" : company_setting.company_tel;
    let doc_type = isCopy ? "( สำเนา )" : "( ต้นฉบับ )";

    let tax_invoice_total_text = ThaiBaht(tax_invoice_total);
    let tax_invoice_amount = parseFloat(
      Number(this.state.tax_invoice_amount)
    ).toFixed(2);
    let tax_invoice_no = this.state.tax_invoice_no;
    let tax_invoice_number =
      this.state.tax_invoice_number === null
        ? "-"
        : this.state.tax_invoice_number;

    let gearbox_amount = parseFloat(Number(this.state.gearbox_amount));
    let debt_insurance_amount = parseFloat(
      Number(this.state.debt_insurance_amount)
    );

    let code_item = this.state.code_item;

    let invoiceNoRow;
    if (
      tax_invoice_no === null ||
      tax_invoice_no === "" ||
      tax_invoice_no === "-"
    ) {
      invoiceNoRow = [
        { text: "", style: "normal" },
        {
          text: "เลขที่ " + tax_invoice_number,
          style: "normalRight",
          colSpan: 2,
          marginTop: 10,
        },
        "",
      ];
    } else {
      // {text: '', style: 'normalCenter'},
      invoiceNoRow = [
        { text: "เล่มที่ " + tax_invoice_no, style: "normal", marginTop: 10 },
        {
          text: "เลขที่ " + tax_invoice_number,
          style: "normalRight",
          colSpan: 2,
          marginTop: 10,
        },
        "",
      ];
    }

    let vatPercentText =
      this.state.company_setting === null
        ? "-"
        : String(this.state.company_setting.vat);

    let headerLeft;
    let headerCenter;

    headerLeft = {
      image: carBase64Img,
      width: 96,
    };
    headerCenter =
      company_name +
      "\n" +
      company_address +
      " เลขประจำตัวผู้เสียภาษี " +
      juristic_number +
      " " +
      " " +
      " โทร. " +
      company_tel;

    let car_license_new =
      car_sell.car_license_plate_new + " " + car_sell.province_name_new;
    let car_license_old =
      car_sell.car_license_plate_old + " " + car_sell.province_name_old;
    let car_license = use_old_license === 1 ? car_license_old : car_license_new;

    let rowOptions = [
      [
        { text: "รหัสสินค้า", style: "myCellBold" },
        { text: "รายการ", style: "myCellBold", colSpan: 2 },
        "",
        { text: "จำนวน", style: "myCellBold" },
        { text: "จำนวนเงิน", style: "myCellBold" },
      ],
      [
        { text: code_item, style: "myCellDetail" },
        {
          columns: [
            { width: "25%", text: "ค่ารถยนต์", style: "myCellSmall" },
            {
              width: "75%",
              style: "myCellSmall",
              text: car_sell.car_brand_name + " " + car_sell.car_sub_model_name,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        { text: "1", style: "myCellDetail" },
        {
          text: NumberUtil.addCommas(
            String(tax_invoice_amount - gearbox_amount - debt_insurance_amount)
          ),
          style: "myCellPrice",
        },
      ],
      [
        { text: "", style: "myCellDetail" },
        {
          columns: [
            { width: "25%", text: "ทะเบียน", style: "myCellSmall" },
            { width: "75%", style: "myCellSmall", text: car_license },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        { text: "", style: "myCellPrice" },
        { text: "", style: "myCellPrice" },
      ],
      [
        { text: "", style: "myCellDetail" },
        {
          columns: [
            {
              width: "25%",
              text: "ปี " + car_sell.car_year_name,
              style: "myCellSmall",
            },
            {
              width: "75%",
              style: "myCellSmall",
              text: "สี " + car_sell.car_color_name,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        { text: "", style: "myCellPrice" },
        { text: "", style: "myCellPrice" },
      ],
      [
        { text: "", style: "myCellDetail" },
        {
          columns: [
            { width: "25%", text: "เลขตัวถัง", style: "myCellSmall" },
            {
              width: "75%",
              style: "myCellSmall",
              text: car_sell.car_number.toUpperCase(),
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        { text: "", style: "myCellPrice" },
        { text: "", style: "myCellPrice" },
      ],
      [
        { text: "", style: "myCellDetail" },
        {
          columns: [
            { width: "25%", text: "เลขเครื่องยนต์", style: "myCellSmall" },
            {
              width: "75%",
              style: "myCellSmall",
              text: car_sell.car_num_engines.toUpperCase(),
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        { text: "", style: "myCellPrice" },
        { text: "", style: "myCellPrice" },
      ],
      [
        { text: "", style: "myCellDetail" },
        {
          columns: [
            { width: "25%", text: "เกียร์รถ", style: "myCellSmall" },
            {
              width: "75%",
              style: "myCellSmall",
              text: car_sell.car_gear_name,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        { text: "", style: "myCellPrice" },
        { text: "", style: "myCellPrice" },
      ],
    ];

    if (port !== 9038 && port !== 9039) {
      if (gearbox_amount > 0) {
        let rowGearbox = [
          { text: "", style: "myCellDetail" },
          {
            columns: [
              {
                width: "30%",
                text: "ประกันเครื่องเกียร์",
                style: "myCellSmall",
              },
              {
                width: "70%",
                style: "myCellSmall",
                text: "",
              },
            ],
            columnGap: 0,
            lineHeight: 1,
            colSpan: 2,
          },
          "",
          { text: "", style: "myCellPrice" },
          {
            text: NumberUtil.addCommas(String(gearbox_amount)),
            style: "myCellPrice",
          },
        ];
        rowOptions.push(rowGearbox);
      }

      if (debt_insurance_amount > 0) {
        let rowDebt = [
          { text: "", style: "myCellDetail" },
          {
            columns: [
              {
                width: "30%",
                text: "ประกันภาระหนี้",
                style: "myCellSmall",
              },
              {
                width: "70%",
                style: "myCellSmall",
                text: " ",
              },
            ],
            columnGap: 0,
            lineHeight: 1,
            colSpan: 2,
          },
          "",
          { text: "", style: "myCellPrice" },
          {
            text: NumberUtil.addCommas(String(debt_insurance_amount)),
            style: "myCellPrice",
          },
        ];
        rowOptions.push(rowDebt);
      }
    }

    let rowBuyer = [
      { text: "", style: "myCellDetail" },
      {
        columns: [
          { width: "25%", text: "ผู้ซื้อ", style: "myCellSmall" },
          {
            width: "75%",
            style: "myCellSmall",
            text: car_sell.customer_name + " " + car_sell.customer_lastname,
          },
        ],
        columnGap: 0,
        lineHeight: 1,
        colSpan: 2,
      },
      "",
      { text: "", style: "myCellPrice" },
      { text: "", style: "myCellPrice" },
    ];

    if (port !== 9039) {
      rowOptions.push(rowBuyer);
    }

    let rowSumAll = [
      {
        text: "",
        style: "myCellBold",
        colSpan: 2,
        border: [true, false, true, false],
      },
      "",
      { text: "รวมเงิน (บาท)", style: "smallRightBold", colSpan: 2 },
      "",
      {
        text: NumberUtil.addCommas(String(tax_invoice_amount)),
        style: "myCellPrice",
      },
    ];

    let rowVat = [
      {
        text: "(" + tax_invoice_total_text + ")",
        style: "smallCenterBold",
        colSpan: 2,
        border: [true, false, false, false],
      },
      "",
      {
        text: "ภาษีมูลค่าเพิ่ม " + vatPercentText + "%",
        style: "smallRightBold",
        colSpan: 2,
        border: [true, true, true, true],
      },
      "",
      {
        text: NumberUtil.addCommas(tax_invoice_vat.toFixed(2).toString()),
        style: "myCellPrice",
      },
    ];

    let rowTotal = [
      {
        text: "จำนวนเงินทั้งสิ้น ( ตัวอักษร )",
        style: "smallCenterBold",
        colSpan: 2,
        border: [true, false, false, true],
      },
      "",
      {
        text: "ยอดเงินสุทธิ (บาท)",
        style: "smallRightBold",
        colSpan: 2,
        border: [true, true, true, true],
      },
      "",
      {
        text: NumberUtil.addCommas(tax_invoice_total.toFixed(2).toString()),
        style: "myCellPrice",
      },
    ];

    let rowEmpty = [
      {
        text: "\n",
        style: "normalCenter",
        colSpan: 5,
        border: [false, false, false, false],
      },
      "",
      "",
      "",
      "",
    ];

    rowOptions.push(rowSumAll);
    rowOptions.push(rowVat);
    rowOptions.push(rowTotal);
    rowOptions.push(rowEmpty);

    // pageMargins : [left, top, right, bottom]
    let docDefinition = {
      pageOrientation: "portrait",
      pageSize: "A4",
      pageMargins: [55, 30, 55, 0],
      // background: {image: 'book', width: 600},
      content: [
        {
          table: {
            widths: ["15%", "70%", "15%"],
            body: [
              [
                headerLeft,
                {
                  text: headerCenter,
                  style: "textBold2",
                  colSpan: 2,
                  margin: [30, 0, 0, 0],
                },
                "",
              ],
              [
                { text: "", style: "normalCenter", margin: [0, 15, 0, 0] },
                {
                  text: "ใบเสร็จรับเงิน / ใบกำกับภาษี",
                  style: "textBoldCenter",
                  margin: [0, 15, 0, 0],
                },
                { text: "", style: "normalCenter", margin: [0, 15, 0, 0] },
              ],
              /*[
                {text: '' , style: 'normalCenter'},
                {text: 'RECEIPT / TAX INVOICE', style: 'textBoldCenter'},
                {text: '' , style: 'normalCenter'},
              ],*/
              [
                { text: " ", style: "normalCenter" },
                { text: doc_type, style: "normalCenter" },
                { text: " ", style: "normalRight" },
              ],
              invoiceNoRow,
              [
                { text: " ", style: "normalCenter" },
                {
                  text: "วันที่ " + date_receive_thai,
                  style: "normalRight",
                  colSpan: 2,
                },
                "",
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          columns: [
            { width: "15%", text: "นามลูกค้า", style: "textBold" },
            { width: "85%", style: "normal", text: tax_invoice_name },
          ],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          columns: [
            { width: "15%", text: "ที่อยู่", style: "textBold" },
            { width: "85%", style: "normal", text: tax_invoice_address1 },
          ],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          columns: [
            { width: "15%", text: "", style: "normal" },
            { width: "85%", style: "normal", text: tax_invoice_address2 },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 0, 0, 0],
        },
        {
          columns: [
            { width: "15%", text: "", style: "normal" },
            {
              width: "85%",
              style: "normal",
              text: "เลขประจำตัวผู้เสียภาษี " + tax_invoice_tax_id,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 0, 0, 20],
        },
        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: ["14%", "44%", "12%", "12%", "18%"],
            // heights: [20, 30],
            body: rowOptions,
          },
          columnGap: 0,
        },
        /*{
          table: {
            widths: [ '25%', '15%', '15%', '45%' ],
            body: [
              [
                {text: ' ชำระโดย ', style: 'body', border: [false, false, false, false]},
                {
                  columns: [
                    {
                      svg: '<svg width="12" height="12">' +
                          '  <rect x="1" y="2" width="10" height="10" style="fill:white;stroke:black;stroke-width:1;opacity:1" />\n' +
                          '  ............ ' +
                          '</svg>',
                      width: 12,
                    },
                    { width: '85%', style: 'body',
                      text: 'เงินสด',
                    },
                  ],
                  columnGap: 6,
                  lineHeight:1,
                  border: [false, false, false, false]
                },
                {
                  columns: [
                    {
                      svg: '<svg width="12" height="12">' +
                          '  <rect x="1" y="2" width="10" height="10" style="fill:white;stroke:black;stroke-width:1;opacity:1" />\n' +
                          '  ............ ' +
                          '</svg>',
                      width: 12,
                    },
                    { width: '85%', style: 'body',
                      text: 'เงินโอน',
                    },
                  ],
                  columnGap: 6,
                  lineHeight:1,
                  border: [false, false, false, false]
                },
                {
                  columns: [
                    {
                      svg: '<svg width="12" height="12">' +
                          '  <rect x="1" y="2" width="10" height="10" style="fill:white;stroke:black;stroke-width:1;opacity:1" />\n' +
                          '  ............ ' +
                          '</svg>',
                      width: 12,
                    },
                    { width: '85%', style: 'body',
                      text: 'เช็ค',
                    },
                  ],
                  columnGap: 6,
                  lineHeight:1,
                  border: [false, false, false, false]
                },
              ],
            ]
          }
        },*/
        {
          table: {
            widths: ["34%", "33%", "33%"],
            body: [
              [
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: "",
                  style: "smallCenter",
                  border: [true, true, true, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [true, true, true, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [true, true, true, false],
                },
              ],
              [
                {
                  text: "",
                  style: "smallCenter",
                  border: [true, false, true, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [true, false, true, false],
                },
                {
                  text: "ในนาม " + company_name,
                  style: "smallCenter",
                  border: [true, false, true, false],
                },
              ],
              [
                {
                  text: "",
                  style: "smallCenter",
                  border: [true, false, true, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [true, false, true, false],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [true, false, true, false],
                },
              ],
              [
                {
                  text: "ผู้รับเงิน  .....................................................",
                  style: "smallCenter",
                  border: [true, false, true, false],
                },
                {
                  text: "ผู้รับใบเสร็จ  ............................................",
                  style: "smallCenter",
                  border: [true, false, true, false],
                },
                {
                  text: "............................................................",
                  style: "smallCenter",
                  border: [true, false, true, false],
                },
              ],
              [
                {
                  text: " ลงวันที่  ...................................................... ",
                  style: "smallCenter",
                  border: [true, false, true, true],
                },
                {
                  text: " ลงวันที่  ................................................... ",
                  style: "smallCenter",
                  border: [true, false, true, true],
                },
                {
                  text: " ผู้มีอำนาจลงนาม ",
                  style: "smallCenter",
                  border: [true, false, true, true],
                },
              ],
            ],
          },
        },
      ],
      images: {
        emptySeal:
          "data:image/png;base64,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",
      },
      styles: {
        normal: {
          fontSize: 16,
        },
        normalCenter: {
          fontSize: 16,
          alignment: "center",
        },
        normalRight: {
          fontSize: 16,
          alignment: "right",
        },
        textBold: {
          fontSize: 16,
          bold: true,
        },
        textBold2: {
          fontSize: 15,
          bold: true,
        },
        textBoldCenter: {
          fontSize: 16,
          bold: true,
          alignment: "center",
        },
        smallCenter: {
          fontSize: 14,
          alignment: "center",
        },
        smallCenterBold: {
          fontSize: 14,
          alignment: "center",
          bold: true,
        },
        smallRightBold: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: "center",
        },
        body: {
          fontSize: 14,
        },
        bodycompany: {
          fontSize: 14,
          bold: true,
        },
        anotherStyle: {
          italic: true,
        },
        myCell: {
          fontSize: 16,
          // fillColor: '#BEBEBE',
          alignment: "center",
          // bold: true,
        },
        myCellBold: {
          fontSize: 14,
          // fillColor: '#BEBEBE',
          alignment: "center",
          bold: true,
        },
        myCellSmall: {
          fontSize: 14,
        },
        myCellDetail: {
          fontSize: 14,
          alignment: "center",
        },
        myCellPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumText: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "left",
          bold: true,
        },
        myCellSumCost: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "right",
          bold: true,
        },
        myCellSumTextCost: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "left",
          bold: true,
        },
        myCellSumTextCostNum: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "right",
          bold: true,
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };
    pdfMake.createPdf(docDefinition).open();
  }

  //เต็นท์ scauto port 9048
  printTaxInvoiceNoModelNoSubModel(isCopy) {
    const {
      company_setting,
      date_receive_thai,
      carBase64Img,
      sealBase64Img,
      tax_invoice_name,
      tax_invoice_address1,
      tax_invoice_address2,
      tax_invoice_tax_id,
      tax_invoice_total,
      tax_invoice_vat,
      tax_invoice_payee,
      car_sell,
      use_old_license,
    } = this.state;
    // let moneyText = ThaiBaht(car_sell_pay.car_sell_pay_count)

    let taxInvoicePayee;
    if (tax_invoice_payee === null || tax_invoice_payee === "") {
      taxInvoicePayee = [
        {
          text: "(..........................................................................)",
          style: "smallCenter",
        },
      ];
    } else {
      taxInvoicePayee = [
        { text: "( " + tax_invoice_payee + " )", style: "smallCenter" },
      ];
    }

    let company_name = company_setting.company_name;
    let company_address = company_setting.company_address;
    let juristic_number = company_setting.juristic_number;
    let company_tel =
      company_setting.company_tel === "" ? "-" : company_setting.company_tel;
    let doc_type = isCopy
      ? "สำเนา (เอกสารออกเป็นชุด)"
      : "ต้นฉบับ (เอกสารออกเป็นชุด)";

    let tax_invoice_total_text = ThaiBaht(tax_invoice_total);
    let tax_invoice_amount = parseFloat(
      String(this.state.tax_invoice_amount)
    ).toFixed(2);
    //let tax_invoice_amount_car =  parseFloat(Number(this.state.tax_invoice_total)).toFixed(2);
    let tax_invoice_amount_car;

    if (
      this.state.car_sell_type_id === 1 &&
      car_sell.customer_type === "customer"
    ) {
      tax_invoice_amount_car = parseFloat(
        String(this.state.tax_invoice_total)
      ).toFixed(2);
    } else {
      tax_invoice_amount_car = parseFloat(
        String(this.state.tax_invoice_amount)
      ).toFixed(2);
    }

    let tax_invoice_no = this.state.tax_invoice_no;
    let tax_invoice_number =
      this.state.tax_invoice_number === null
        ? "-"
        : this.state.tax_invoice_number;

    //let head_line3 = 'โทร. '+ company_tel + ' เลขประจำตัวผู้เสียภาษี '+ juristic_number
    let head_line3 =
      " เลขประจำตัวผู้เสียภาษี " + juristic_number + " เบอร์โทร " + company_tel;

    let invoiceNoRow;
    if (
      tax_invoice_no === null ||
      tax_invoice_no === "" ||
      tax_invoice_no === "-"
    ) {
      invoiceNoRow = [
        { text: "", style: "normalNo", margin: [0, 15, 0, 0] },
        {
          text: "เลขที่ " + tax_invoice_number,
          style: "normalRightBold",
          colSpan: 2,
          margin: [0, 15, 0, 0],
        },
        "",
      ];
    } else {
      // {text: '', style: 'normalCenter'},
      invoiceNoRow = [
        {
          text: "เล่มที่ " + tax_invoice_no,
          style: "normalNo",
          margin: [0, 15, 0, 0],
        },
        {
          text: "เลขที่ " + tax_invoice_number,
          style: "normalRightBold",
          colSpan: 2,
          margin: [0, 15, 0, 0],
        },
        "",
      ];
    }

    let customerBuyRow;
    //finance car_sell_type_id === 2
    if (port === 9048 && car_sell.car_sell_type_id === 2) {
      customerBuyRow = [
        { text: "", style: "myCellDetail", border: [true, false, false, true] },
        {
          columns: [
            { width: "25%", text: "ผู้ซื้อ", style: "myCellSmall" },
            {
              width: "75%",
              style: "myCellSmall",
              text: car_sell.customer_name + " " + car_sell.customer_lastname,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        { text: "", style: "myCellPrice" },
      ];
    }

    let vatPercentText =
      this.state.company_setting === null
        ? "-"
        : String(this.state.company_setting.vat);

    let headerLeft;
    let headerCenter;
    if (Number(port) === 9008) {
      // roddee
      headerLeft = { text: "", style: "textBoldHead" };
      headerCenter =
        company_name +
        "\n" +
        company_address +
        "\n" +
        "เลขประจำตัวผู้เสียภาษี " +
        juristic_number;
    } else {
      let logo_width = 110;

      if (company_address.length >= 60 || head_line3.length >= 60) {
        logo_width = 100;
      } else if (company_address.length >= 57 || head_line3.length >= 57) {
        logo_width = 96;
      }

      if (port === 9000) {
        logo_width = 80;
      }

      if (port === 9048) {
        logo_width = 215;
      }

      headerLeft = {
        image: carBase64Img,
        width: logo_width,
        margin: [0, 0, 0, 0],
      };
      headerCenter = company_name + "\n" + company_address + "\n" + head_line3;
    }

    let imageEmptySeal = {
      image: "emptySeal",
      width: 80,
      border: [false, false, false, false],
      rowSpan: 3,
    };

    let car_license_new =
      car_sell.car_license_plate_new + " " + car_sell.province_name_new;
    let car_license_old =
      car_sell.car_license_plate_old + " " + car_sell.province_name_old;
    let car_license = use_old_license === 1 ? car_license_old : car_license_new;

    let tableDetail1 = [
      [
        { text: "จำนวน", style: "myCellBold" },
        { text: "รายการ", style: "myCellBold", colSpan: 2 },
        "",
        { text: "จำนวนเงิน", style: "myCellBold" },
      ],
      [
        {
          text: "1",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            { width: "25%", text: "ค่ารถยนต์", style: "myCellSmall" },
            {
              width: "75%",
              style: "myCellSmall",
              text: car_sell.car_brand_name,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        {
          text: NumberUtil.addCommas(String(tax_invoice_amount_car)),
          style: "myCellPrice",
        },
      ],
      [
        {
          text: "",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            { width: "25%", text: "เลขทะเบียน", style: "myCellSmall" },
            { width: "75%", style: "myCellSmall", text: car_license },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        { text: "", style: "myCellPrice" },
      ],
      [
        {
          text: "",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            {
              width: "25%",
              text: "ปี " + car_sell.car_year_name,
              style: "myCellSmall",
            },
            {
              width: "75%",
              style: "myCellSmall",
              text: "สี " + car_sell.car_color_name,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        { text: "", style: "myCellPrice" },
      ],
      [
        {
          text: "",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            { width: "25%", text: "หมายเลขเครื่อง", style: "myCellSmall" },
            {
              width: "75%",
              style: "myCellSmall",
              text: car_sell.car_num_engines.toUpperCase(),
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        { text: "", style: "myCellPrice" },
      ],
      [
        {
          text: "",
          style: "myCellDetail",
          border: [true, false, false, false],
        },
        {
          columns: [
            { width: "25%", text: "หมายเลขถัง", style: "myCellSmall" },
            {
              width: "75%",
              style: "myCellSmall",
              text: car_sell.car_number.toUpperCase(),
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          colSpan: 2,
        },
        "",
        { text: "", style: "myCellPrice" },
      ],

      /*[
        {text: '', style: 'myCellDetail',border: [true,false,false,true]},
        {
          columns: [
            { width: '25%',
              text: port === 9048 &&  car_sell.car_sell_type_id === 1 ? ' ' : 'ผู้ซื้อ', style: 9048 &&  car_sell.car_sell_type_id === 1 ? 'myCellSmallWhite' : 'myCellSmall',
            },
            { width: '75%', style: 'myCellSmall',
              text: port === 9048 &&  car_sell.car_sell_type_id === 1 ? ' ' : car_sell.customer_name+' '+ car_sell.customer_lastname,
            },
          ],
          columnGap: 0,
          lineHeight:1,
          colSpan: 2,
        },
        '',
        {text: '', style: 'myCellPrice'}
      ]*/
    ];

    if (port === 9048 && car_sell.car_sell_type_id === 2) {
      //console.log('customerBuyRow', customerBuyRow)
      tableDetail1.push(customerBuyRow);
      //console.log('tableDetail1', tableDetail1)
    }

    let tableDetail2 = [
      [
        {
          text: "",
          style: "myCellBold",
          colSpan: 2,
          border: [true, true, false, false],
        },
        "",
        { text: "รวมเป็นเงิน", style: "smallRightBold" },
        {
          text: NumberUtil.addCommas(String(tax_invoice_amount)),
          style: "myCellPrice",
        },
      ],
      [
        {
          text: "(" + tax_invoice_total_text + ")",
          style: "smallCenterBold",
          colSpan: 2,
          border: [true, false, false, false],
        },
        "",
        {
          text: "ภาษีมูลค่าเพิ่ม " + vatPercentText + "%",
          style: "smallRightBold",
          border: [true, true, true, true],
        },
        {
          text: NumberUtil.addCommas(tax_invoice_vat.toFixed(2).toString()),
          style: "myCellPrice",
        },
      ],
      [
        {
          text: "(ตัวอักษร)",
          style: "smallCenterBold",
          colSpan: 2,
          border: [true, false, false, true],
        },
        "",
        {
          text: "จำนวนเงินรวมทั้งสิ้น",
          style: "smallRightBold",
          border: [true, true, true, true],
        },
        {
          text: NumberUtil.addCommas(tax_invoice_total.toFixed(2).toString()),
          style: "myCellPrice",
        },
      ],
      [
        {
          text: "\n",
          style: "normalCenter",
          colSpan: 4,
          border: [false, false, false, false],
        },
        "",
        "",
        "",
      ],
      [
        {
          text: "\n",
          style: "normalCenter",
          colSpan: 4,
          border: [false, false, false, false],
        },
        "",
        "",
        "",
      ],
    ];

    let tableDetail = [...tableDetail1, ...tableDetail2];

    // pageMargins : [left, top, right, bottom]
    let docDefinition = {
      pageOrientation: "portrait",
      pageSize: "A4",
      pageMargins: [30, 40, 30, 0],
      // background: {image: 'book', width: 600},
      content: [
        {
          table: {
            widths: ["15%", "70%", "15%"],
            body: [
              [
                headerLeft,
                {
                  text: headerCenter,
                  style: "textBoldHead",
                  margin: [140, 0, 0, 0],
                  colSpan: 2,
                },
              ],
              [
                { text: "", style: "normalCenter" },
                {
                  text: "ใบกำกับภาษี / ใบเสร็จรับเงิน",
                  style: "textBoldCenter",
                  margin: [0, 25, 0, 0],
                },
                { text: "", style: "normalRight" },
              ],
              [
                { text: " ", style: "normalCenter" },
                { text: doc_type, style: "normalCenter" },
                { text: " ", style: "normalRight" },
              ],
              invoiceNoRow,
              [
                { text: " ", style: "normalCenter" },
                {
                  text: "วันที่ " + date_receive_thai,
                  style: "normalRight",
                  colSpan: 2,
                },
                "",
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          columns: [
            { width: "15%", text: "นามลูกค้า", style: "textBold" },
            { width: "85%", style: "normal", text: tax_invoice_name },
          ],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          columns: [
            { width: "15%", text: "ที่อยู่", style: "textBold" },
            { width: "85%", style: "normal", text: tax_invoice_address1 },
          ],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          columns: [
            { width: "15%", text: "", style: "normal" },
            { width: "85%", style: "normal", text: tax_invoice_address2 },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 0, 0, 0],
        },
        {
          columns: [
            { width: "15%", text: "", style: "normal" },
            {
              width: "85%",
              style: "normal",
              text: "เลขประจำตัวผู้เสียภาษี " + tax_invoice_tax_id,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 0, 0, 20],
        },
        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: ["14%", "48%", "22%", "16%"],
            // heights: [20, 30],
            body: tableDetail,
          },
          columnGap: 0,
        },
        {
          table: {
            widths: ["45%", "5%", "45%"],
            body: [
              [
                {
                  text: "ลงชื่อ......................................................................ผู้จ่ายเงิน",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 25, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 25, 0, 0],
                },
                {
                  text: "ลงชื่อ......................................................................ผู้รับเงิน",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 25, 0, 0],
                },
              ],
              [
                {
                  text: "(..........................................................................) ",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-12, 2, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 2, 0, 0],
                },
                {
                  text: taxInvoicePayee,
                  border: [false, false, false, false],
                  margin: [-6, 2, 0, 0],
                },
              ],
              [
                {
                  text: "วันที่ .........................................................................",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-22, 2, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 2, 0, 0],
                },
                {
                  text: "วันที่ .........................................................................",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-16, 2, 0, 0],
                },
              ],
            ],
          },
        },
      ],
      images: {
        emptySeal:
          "data:image/png;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QMtaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA3LjAtYzAwMCA3OS5kYWJhY2JiLCAyMDIxLzA0LzE0LTAwOjM5OjQ0ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjIuNCAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MUM5QjI0MTAyREI1MTFFRDgzRkQ5OUM5RkI4N0I4NjkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MUM5QjI0MTEyREI1MTFFRDgzRkQ5OUM5RkI4N0I4NjkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxQzlCMjQwRTJEQjUxMUVEODNGRDk5QzlGQjg3Qjg2OSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxQzlCMjQwRjJEQjUxMUVEODNGRDk5QzlGQjg3Qjg2OSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pv/uAA5BZG9iZQBkwAAAAAH/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAgICAgICAgICAgMDAwMDAwMDAwMBAQEBAQEBAgEBAgICAQICAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDA//AABEIAZ8BrAMBEQACEQEDEQH/xACDAAEBAQACAwEBAQAAAAAAAAAACQgGBwMEBQEKAgEBAAAAAAAAAAAAAAAAAAAAABAAAAYDAAECBAMEBQoFBQAAAAIDBAUGAQcIERIJISITFDEVFkEjFxhRMkIzJLJDUzS2N3c4eDlhJSa3GVK1drh5EQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD+/gAAAAAAAAAAAAAAAAAAAAAAAAAAcdtdwqVDgn1pvFortMrMWn9aTsdrm4yuwUcl8f3r6Xl3LOPaJ/D+sooXADCzz3T+IHjxzFat2xNdNzTZZRoeK481Rt3rvBHyRspqs305znRtk1WCUQULkqykk/ZoNzYzhVRPxkB4sdkdKXH4af8AbT6efNFP9VtO+b7zXz5VHHnPyGNEOdw7A3WwLjHzH+6pSBi4zjGMGN5LgPKSx+6pbM4OhqbgrRzVX+5zNby370hMIJ5+GFJCJhtEc1RKTnH4mQQlnKePww4N/WAe2hqn3L5jyay9p8o1pNTGf8Hq/g6/tHjTGfwJid2P2/sRo/VJ/pfylsU3+ix+0Pw3LnY0ib1y3ubbnism8epKgc58fQjYvzYznCJb3pbaDkmPT5xj1qqZx8Px/aDHHPSR8+pf3X+8CZ9JS4LH6w9r9ul5x6smOYr7255VXJjZz+w+MYxj8PPnOQ/P5Qen2/xZ+6v2g6MXJvTiw6h9tx+mYuT4NjCxYHhCqqGMUvy+SHTx4/Z5+IDx/wAuHdcZ8YL3IpKWMX4kLszknRViSPn9mHBdcqaeUUJ5/HCZ0s5x+GcfiA/z+jPdQrnnLTofg/azcmP3TKe5K3zpqVU8f2Hlng+w9wxahj/6RKARwX/R5AeE23vcwp/wt3FPN+02KXxzI6E7PnmlleEx/W9NE3lzTq+ux7jPjyQmbg5Ibz4MoTx5AePPuDuaj8N8cQd8aOTR+DyVR0NH9OQCBcefW8K/4fu/T78kYXGPXlZyzamTT+ZZNLwbBQ7M1X7hPEO6bASma86i01IbCOZMhtWT1yjqLt5udU3oTK+1HfD1rZUeZRTGS4wvFJ+T4yX+tjOMBsYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdObs6G0TzdVMXjf239dadqii+GTOZ2JboWrN5aSP6CoQ8EnLPGzmwTrxRQhG7BiRw8cKnKRJI5zFLkMfl7i3LuP9xxpxVuHZ0S4+VlunphV7xfoVQqvyoPmSWyarP8ATVpjj/FVJ1EaxdxjtEuDJPvCiZjB5cc392bg/fdA9xp6ggHXzL6v4W1TXtenK3/H8ond9b5/jfsWfx5+J5GtxlBdHxjGCES+b1hyep+2Jw/Xp1jcrRo6N3xsSOU+5abP6rs1z6v2OyfGzjKr+GuHRVh2VLVddQ39VOJOwbokz9NFNNLGCYDdrJkyjWjaPjmjVgwZoptmbJk3SatGjdEuCJINmyBE0UEUiYxgpClwUuMeMYAe0AAAAAAAAAAAAA6v2rpDS29q+epbv1DrDcdVUwoVStbUoNV2DAHwqX0qYND22Kl4/P1C/DP7v4gMZ59snTVJx9zy7tTpbi9+l87KP553TOK6rZKp/Fv9vzduhtt/mZqgnnHpMVtT251Evkyf04J6Q8eW/uh6R+dvI809301r8cs5JnOcc9BJs8fDOSS8ebcuh9kz+PGMlTzH64YnxnOMqJ+nGTh78J7mOg4SYjaf0/Xtp8L3yTeoRLKH63qTWg0CZmFz4QRi6h0jW5m58uXaQeOs/TbM4y6uJJbJyeWpDKFLkKEM3jSRaNZCPdNnzB83RdsnrNdJy0eNHKZVm7pq5QMdFw3XRPg5DkNkpi5xnGc4yA9kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZF392/oLnmxxut52ZsOx97WJhmSqPNuj6vK7b39Z2GTFISXS11U03T2rVLKhvSpYrErDVprnzlzII4xnIDoosR7jfUGPqWGerPty6if584r1IzS+guz5iMU+XKcxeZphYOZNEyiqJzFWbRUVs9UnynbyzZXGcYDunSPBPL+iLXnZsDQF79vJwhlCT6L3lY7BvHoKSIf15cNybb2fIWW212FXUUMYsPDLxkI3x4I3ZoplIQobGAAAAAAAAAAAAAAAAAAAAAAHypyChLNDyVeskPFWGAmWa8fLwc5HtJaHlY9yTKbljJRj9FwyfM3CeclOkqQxDlz4zjOAE8X3tt0nWzx1ZOHdr7G4TsizlaQUpmozR1p5anXy6hlViWbki9pymoYpq+OobLp1S0aVPuM5xn80Lkpc4D55+supOac/a9u85K2zXzPHhbrHimFuW1dfNGifxVmNr80LpzfRWn0SplMqseCxsmEZIEyq8lmxPhgN26o3Bqre9FhdnaW2NS9q68sSRlYW50CyRVqrr/ACnnBXCCUpDunbUj1krn6bhucxV2yuMpqkIcuS4DsYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABnTorq7RnLMHCSm37iZhN3GQVg9a62q8PMXrb+3LQmlhUtT1LqioMZm+bDsRimKZRGMYrlaJZyu5Og3KdUoZNRrvd/Yxiu7xMzft386vsetvryhS9Vtnb+xIhbOTJFvu0WZbRq3mRk/beCrxdR/VNoIQ/rSskO6IZEgbG0JzJofmKuyNa0draCoyE8/wATFvnUjP5y97CsPpMRS1bO2PZXkzftm25wU2cKy09JSMipj4GWzjGMYDvcAAAAAAAAAAAAAAAAAAAAAAAAAAAABhTbPA+tLVdprdmibXcOQuk5pUr2Z3ToE0PDpbDfIY8oE33qWajpXUe/mB/SVIy1kh3M41beokbJxymcLFDqsnZe6uUlUYH3GNdwcHr9FQjNj3XoSOsMtzS6T9f0UH+/KDIuJ7Y3JLxyYxPrPZNzZaGgY3lWztjmI2wFKoKdhLRCxVkrUzFWKuz0czl4OegpBpLwszEyCBHTCTipSPWcMZGOfNlSqIrIqHTVTNgxTZxnGQH1QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeNZZJukquuqmgggmdZZZY5U0kUky5OoqqofJSJppkLnJjZzjGMY85ATCmewNudYTMtrn24oysS1QjZJ7Xb/3tsiMeTPOVKetHCjCXi+fayxfRMh1rseIWRVTMrGvo+hRbsnpeTbp0irEKBoPnPivU/PU5ObMVfWvdHRt2j0o/ZHUG65JpcN1XJmmrlyWvs5dCPjIDXGu2bnPrZVKpx8HWGWcYOkxwtk6pw18AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8ayKThJVBdJNdBdM6KyKxCqJLJKFyRRJVM+DEUTUIbODFzjOM4z4yAmXYOJthc3zUts723bTW9VGkJJ5YbvxhsFaTJx1tiQfLqOph5UGEMzlJzlDY8wqqZT88pzRavOnecrS9blFj/cJh3lzf2hQt9WGe1JZ61aNA9RUSMSk9kcxbcxGx2xYSMM4+x/WlIkYx4+qu5dRP3+PpsrdVnklEKGMVByZm+wqySDYwAAAAAAAAAAAAAAAAAAAAAAAAAAAADpnfnQWoOYtaTG293XRhSaVELsY5Nyug9k5mw2KYXwzr1NpdYh2z+yXe9WmRMVrFQsS1eSck6OVJugofPgBgNjpXe/uHnTtPYcBZdA8eulCPaZwqnLEYbI3PFYP9WOsHclorj5YrWAkkfSsXUkI8PFEIb6dnfSxjKRLIKnQkHC1mGia5W4iLr9egY5lDwcFCR7SKhoaIjW6bOOi4mLYJN2MdHMGiJEkUESESSTLgpS4LjGAH1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGbOlOUNP9UV6CjdjR0zEW6iyitk1LuPX005pW6dKXI7f7clw1TsWLL+cViVOljCbttn68VLtfUzk2j1koq2OGUal1HuDkm1V7S3uEyEPK06zTUfVNLd816FaVXVOxZeTclY1+gdK1lkbMTzpvGWXUSbtH5TlolvenwWOXi366UCUKggAAAAAAAAAAAAAAAAAAAAAAAAADLHUfWFJ5ig6uzcQdh2lunako7q2hOeNdkZvtpbquTVqV26j6+zeuGsdAVOttFCvLHZ5ZZpAVqN8uXzlPGUiKh0zoTkO5zWyInrPtuarm1eoWbd7jWNKr2Xj3QnHsDNIZRkKjoOJmWzVzOX2RYn+2sexpNslYp/GDINU4mIySKIFDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHG7jTalsOqWKiX2sQF1pNvhpCvWqo2qIYT9bskDKtlGcnDTkJKIOo6Ui5BqqZNZBdM6ahDZwbGcAJYHU2d7WucHcuLxvD21m5/B3Lo85ft5cDxHn5TuHJvzS27s5BgUvgZRTLy268Yk9RzSsElk0MFWa3Za7cq9BW6oT0NaapZ4iOsFastdk2U1AWCCl2iT+JmoSYjlnMfKRUmxcEWbuEFDpLJHKchslzjID7QAAAAAAAAAAAAAAAAAAAAAAyD1d1ez57a0+i0WmvN1dPbocycJz/z7AySUZK3WTi0m55243KeUbvW+uNJ67RfIu7TaniKjaNbqJN26TyTdx8e7D4nK3JL3Uc3Z99b1uLXeHZO2YpnHbS3KaNVja/Vqw2dGk4vRmgaw8Xeqay0JTn6mTNY8ip5GcfYNKzTh5Iq/UTDbIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPwxcGxkpsYMU2MlMU2MZwbGceM4zjPwzjOAEk7VQrn7Zthndu6ErFgvXBVilpKz775fqMa7nLLy5JyztWSsu/uVqvHpLv5HVqztdaQuutGCZst/WtM1pErjDyJkQqJR7xTtl06r7D17Z4K60W7QMXaKhbqxJtJmvWWuzbNKQiZqFlWKqzOQjZFkuRVJVM5inIbGcZAcpAAAAAAAAAAAAAAAAAAABlXrHqSJ5np9cTiarI7X3ptqw/w9500HW3zZla9xbKXZLP8AEcm+ckWa1WiVKKQVl7XZXhMx1bgWy7tb1qfQbrhxPkrlSW087uG796WmN272Nu5tGn3TtpmyctK7Awkas5e1nRGj4iROs8pGgdZKPlU4tjk33ku9O4mJU68m8WOUNrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkjeYCV9sK62TeWuIqQlPb42DYpC09LaegmbmQccgXGwyCj6x9SaZgGKS6+NFzsk7UfbNqbJP0wqp1bRFpYL+dNnIVdh5iJsMTFz8BKR03BTkcymIWaiHraSiZeJk2yT2OlIuRZqrM38dIM1iKoLpHOmqkcpimyXOMgPogAAAAAAAAAAAAAAAAOkeiugtdcv6itO5dnu5EtfrhY9jGwVej1Jy53y42GRbQNI1tr2tNjFe2rYWwbTINYmFjEP3jx+6TJ5KXJjlDNnI/PGw82+wdldYMo5XrTbdeJARlNZSCU/VeTdIrPUZmE5w1tJkLho/lMukEJG+WNuUh7ZZ0/UU2IqPh2zUKAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPGsii5RVbuEkl266SiK6CyZVUVkVS5IqkqkfBiKJKENnBi5xnGcZ8ZASWqH1PbE21X9Uv1Dp+3dvy7oQOk5lc5sx/E+9rvK+mN0RMuFDZJGcz7osj7JKK5Pkren2h1iuZySNkYNJkFbQAAAAAAAAAAAAAAAeo/fsYpi9lJR60jYyNaOX8jIv3KLNiwYs0TuHb167cHTbtWjVumY6ihzFIQhcmNnGMZyAlpzxGPu9N0wHdV8ZOi806vdzLX29teSzZds3tuX7R5XrN3Raod4RNRSa2PDuXMXrNJwng0TSHK8sXBXViyRkFVgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcE2frKg7o13ddS7UqsReNcbFrUtULrUZ1v9zEz9dnGarGSjnaeDEUJhZurn0KpmIsipgqiZyKFKbAYT5D2TftK7Klvb76NtUtb71R6u7uvK27LSv9eY6c5liHzKIziyyuSJoyvQPPrqSYwV3xjwvLs3MVY8Ex+bOkWYUnAAAAAAAAAAAAAAEtOpXL3tXeuPb4qTtwnpGmxdZ2J7hdpjl1UCyNCsGTSWsuOI6RamKqjPdBEZHk7oQhyLMdctzNVPQazMFiBUFkyZRjJpHRzRrHx8e1bsmDBk3SasmTJqkRBq0aNUCJoNmrZBMpE0yFKQhC4xjGMYAe0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAyR2RzS96O1pF5odka656H09aGe3OY9vrM1Hn8Ntx15m9aRik01bZI6mdcXqFkHlbt8SU2Cy9YlnrfHoWMiqkH2eROkmXUWnGd4d1pzr3ZVWn53V++dRybtN7N6c3pQ104zYmu5N0mVMsizYSByPYeSKQiE5XnzCUb4+2eo5yGngAAAAAAAAAAAZb7D6NU5k0pJXSv1st/2xbZ6v6p5+1WV1lm42tvnYjzMJrekfdE8qx8IpJmNIz0gUpiw1bj5GSVx9FmpnAfnHnNxOYNMMaZM2PN/2vcJ+d2t0Htldrhm/wBu76v66crsa9rts+Tx8QrIFTjoKOyYycJW4+OjEc/QZpYwGpQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAS16UT/AJK+la/3TC4wx0Ruhai6L7xjE/kjq7kz5Kr89dcKJF9CTdfWc5LpU+6vTZx66VLM37o+G9XSKAqUAAAAAAAAAAACX+li57F7MvHUT/H32hOPZO/c28poH/eRdx3l9ZSr9ZdDsslz9B6lV3rI+rK45+J2uY22nTMZvKpmAVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcYu1LqeyKbbNeXyAjLXR73WpynXGrzTYjyHsdXssY5hp+ClWh/kcx0tFPVUFiZ+Bk1M4AYN4BuNroqOzeE9uz0lYdq8cOK3DUy42ByZxO7l5Nuacsbmvbr12vn7iYsLODrshSrS8N6lHNtqEi7N6U3qHqCjIAAAAAAAADDXfu473rrTkNrHSEkSO6Y6pvEVzdzy9wj92ep3C7RkxJ2/cTpiU3rcQvP2poCwXd2XOMpuPyEjTPzuk8GDSOjtNUTnjT2tNGaxjTxNB1RS4CjVdo4Wy7fnjICPRYlkJiQOXC0tPy6qZ3cg9V8rvXy6q6pjKKGNkO1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABM/3AGLvRc1qD3E6o1cmd8quZevdHso1FVV1cOIdmO4hDeOXbZsXCsk40TLw8Psxh6smOmhVpJohjGZRbBwpQ0dtJBo1fsHTd6xet0XbN40WTctHbRymVZu6auETHRcN3CJ8HIcmclOXOM4znGQHsAAAAAAAAmZpTH8znee9ei3eMvtW8eMZnjLn7J/nj5Hb0utX7d2TsuPIfHoWWi5ePrGumrjBcLMXtWsjch8pvFcZCmYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPnTERFWCJlIGdjmUxCTcc9iJiJkmyLyOlIqSbKspCOfs3BFEHbJ60WOkqkcpiKJmyXOM4zkBPH25piT15WNtcNW+RfyFu4Xu7HWVNkZhyq7lrbytcYw9v5Mua71Yyi0oeO1mY9IkHyh8qPbHR5VU2C5z4AUfAAAAAAGYuy9+O+ZeZNubkhIhOy3eAr7aC1RTlDen9ebt2BMxmvNI6/Jn1pmwe97ZtMNE4yXPqL956sYz4AfR5H0C05d5u1DopKYUs0rRaokS63NwX0vdg7PsT15bNsbKk8ehP/AM32Rsuelp15n0lxlzIH8Yxj4YDRgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACa3UBP4Adj8mdbtM4aU/aD5LgzolXHyt/yTbc6excqXWTNn0kMrTOj081Fl5PjBC7Tdnzg3px6QpSAAAAAAJt9Fl/jn3Xx5zeT/ABNR0Wwtfee42ufGWy8lUPutO8t1iUJj1GOnM7QuM/b2XnBSlf62TN6vJcEMFJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABnXrjQrbp/mfdmhFJQ1fkdla/nIWqWtL1YdUjYDZEsvrfYEcYpFDJy1Av8bGzTQ3pN6HTFM3pz48ZD5/Ge+XXTfLekN3y0WWv2u7UaP/AIjVcvp80zbVaWc1Db9GU9J1C/Xo+0ICXiFPjn94yyA00AAAAAnBwpj+Ke0u4uuXGMuG23Oi5PQmr3xvmJjR3FWJPRrJszVN5y4i5TotPZ881VJ4RWbTiZ0/UXOFFAo+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcHIGP4RdT978tq4y1hjbKqHaupmZ8+hJOgddsJ0myWbAvwTXOh1VqbYEw7+njGUMWRthQuMqEOqFHwAAAZ7603cjzVy90L0Cq2K/V01pnY+xo6K9B1VJ2bqlTlJev11sgn+8dPrFONm7FuiT51l3BCF+JsAPm8a6PW5s5R540S/c5kJ3WOoaNWLfMHUIqvY762gmi+wbU8WT/dryFruzh/JOTl8FOu6ObGMYz4AaWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABOXojH8K+++D92pf4WI3JG754gva/wCDVd5cqWl0xpySlDf5s8LYub52Gjz58E+5t50fiddPwFGgAAATq9x4v6yqPLvOxMfVz0323znSJVoX4nf0bTU5K9g7Si1SfHzGz2s+aZaMeZzjx9u/MXzgxy5AUVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATu909FWF4zu+6GSR8ynKF40z2I1XRKYzhCF5e23TNybFbJ4LjJ8oz+p6pPxTnBfmM0fqlx4znyAockqmsmmsioRZFYhFUlUjlUTVTULg5FEzkzkpyHLnGcZxnOM4yA/2AAJ37Yx+uvcz46pv97GaU5u6z6GlS5+bDK5Wee0XoPWS2CfHBDv6hd9gkwfPjOCoGKXzgx/AUQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcA2xryF27qzZep7IQqld2fr+5a8nkzEwoVSFutdkq3KEMmb5VCmYyamMlz8M/gAzb7cuwpnafBXHt2tBjGuchztqmN2AUx8qGQ2RV6hGVXY7MxzeDHMyvMJII5ybGDZyT44xnzgBtEAATy1Jj9We5l2nbD/vGus+Z+LdHRWMfErSafWbqHdF2PjOfPhWUh9iVUpy48eCsk8+Pm8gKGgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACeftrY/ItObr1ab4fwZ7g7jpLNPPn1Na3Y+ndk7hocfkvjHpJF692lEtk/GMYykiU37QFDAABPfizH5zvn3PLyfHr/ADruGvVCKV+PyQOruJeP6cqzKbOMeoiN5bTyvw+GDrmx+OM+QoQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ78dY/I+lPdDpfj0N0+w9cbIiEPGcYRidj8NckJv8lx4xgxXV8qU64ybH4nVNj8cechQgAAT79vDH3lT6rsZvipZfcE7Uyob9pv0Tumd1Uj5z4+P022vyE/8MF8fsAUEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHxLJZq3TYGVtNvsEJVKxBM1JCbsdklmEFAw7BHx9Z9Ky8o4ax8ezS849SqyhCF/bkB9Fi+YyjFnJxjxrIxsi1bvo+QYuEXbF8xdokcNHjN23Oog6aukFCnTUIYxDkNjOM5xnGQHtAAAAAAAA6b6G3HGc+aQ2huqXiXk8x1tT5azmhGChUHMu5ZI+lhGFdHTWIyTfP1UklHGSKYbpmMpkh/T6chjfRvT/UzTeutNLdaa40xXD9B6/t+x9OTWl5+2SBoMtLaxEtOa92KxtpVcPLRGwcymsrIxqpI46hcERKp6z5RDtLoPpq1a86Q5O501pHViwWjd1qn5XYjOYj5eSf1TTdSil3s3aGBoqch0IaQeu0FUGTl6R22UUbLEwic5cYAbaAAAAAAAAAAAAAAAAAAAAAT70Vj8u9w/3AocvwJK6t4d2CYvjOPK85D9CUM6n4eM5MjqxMvn+gmMfsAUEAAE/vbWx69BbVd5xjBnnuA+6fk2fVkxs/l3uX9YwhMnznGMYz9KKLguMfDBMYx+PkBQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYk9yL/kR6m/4RWP/JQAaI0Z/uT07/ws19/slEAO0wAAAAAAAcauVPrGwqnY6LdYVlY6lboWRr1jgpEhlGUrDSzVRm/ZOMEMmqUqzdU2MHIYqhM+DEMU2MZwEkWftZbe1vs9rsnnvvjaFGcxVMX15V0tw6wqXSsvSKOs/SfEp9Gm79PRrep1xthskkmizYpLfTJkpljFOfGQ2jzhxnRufrPcNoyVuvW6N7bCbpsLlunakqlL2x1Ct3GHDWsV9q1QbRVTqrZQiecMmaZcH+ikU5zJoN00g2EAAAAAAAAAAAAAAAAAAAAAn9rLH0fdG7RQxjwVfhb23JXPg2fGVHO9fdFjDZMXOPGFPRCkxnOPxL6f6AFAQABP722PKWh9tMc5z6mPuA+6P6iG9PqTxLe5F1RYk8ZzjxnOFEpoqhfPx9J8fs8AKAgAAAAAAAAAAAAAAAAJidTyVg6F6x1RwpG2ywU3XCuqZvo/ohzUZV9A2W50CNtSNFqetGdjjHTSRhIeftJzmmftzlcrssplKZMuTZOGVI+A1Had1vfbrnfcDcW7R0c9eZR0CdOys9xyhmiZEFOcZ7olJqjATevq4ZrlQsU3fYta6RlI1fOEWpVAGuOHrLdNdbj6h4qudvsWwonn+Uotu05c7a+VmLQrqPacIrLxVNsE0vgriWd0J62y0SdLY+ouRQxS+hBJJJMOhe/KFtLZ3RdVabc0t0pt3hSma1WlpDXvNjuJkZDZu2zymFFyX6tx2yKXdXFersM4QOyK0TO8O8QMVn68KusphwDVPPHt47TsR9TaA6A645TuBEZNCV59h9v7c0vZZGIXP4l4hSk7pjJqQnImVVbqPXJI1Vc2TKqZVMT6Zk0gtBV6fXdK6qiKTrirqlrWtKUnD1GpRyplHbplXInKcbEounOVVXMnI5bFKZdbJ1FnCmVFMmMY2chLnT/t5R/UVTLuz3I4a37H3Xd5efmWer5DYN4rFF0VWl5RVvA0imwNFs0Cg3UJEMkVXax1l8rKKY+oZVYijlcORcuR1l5Z7kv3Ecffrxf9H2HnWL6O1Ow2DPuLRN6qOhsBTX03R4ube+l4vWXzoqrlBE3ytypJY8GWUcuFg9r3QPy37zmX+Nf69/kj/W1//mt/QH62+r6P0YT+E362/h3/AOrP4bfqX7380+h8v1ftvH7/AO3AfE9pnYNOs7LqSm6csFxmOctebeg2ugY+7LzzmSrlHsNOZyS0ZEntWTWVvVFpNE7iLbvM/WTaLFOfGFFFPIah9yL/AJEepv8AhFY/8lAB3tqRy/Z8+aydxTD80lGumqY5jYz6ybf8xfoUmNVZsPuFjERQ+8cFKn6zZwUvq85zjGAH8/NT03rEpZe/+6Xz32xN9Bzk/YJ2Y3yzZbBs+odTNmtkMzrkHrab572PaTw8JWmayUi0NIRWUMKJqkZ4VRTSKsFJuU+V+VrLYqf0NqXpXd/SVVpMjMvNaVa/71e7O1nq2zS0e7jX76EqchGtZiBtTeMk1yFLKrKuUcOfq5J9T6ahQ/17g12nGmxeYdUWLoC08q6A2lJbPPtLeFMtMZrywIz9PrcZL0KhtdoS5FY/XxbK5WeLmXVL4fFZZbl8/NjIepw70w3g+btvXffW829p1BqPeOy9f6p6N2K/Zx73a2qKiWMTgZ1eSMRFW8TmZPL1gk9bEXczLhv6Eiqr4N6g7F9vCxbW2lR9t9D7HlbiWtdAbjst60ZSrbKy701K0agk2iqGnHxkk8cNa+lYm7ZV9lBkRNqumom5Jk2F8ekJ5dzu9GM+pt8uO9ibb/RSOtdaL8GL09XbaNXQuCNZm83k1eU104bwCe4y7HMkogaYz9DDBNv9fOEvoYMGsan1feaD7TVF6HnpZ7bdwSWnYSv1J47b/mczatpWSUzQaGdw1KkqrOSasw4auXfqKZR1hJVRTOcmOYBn3PKjHjLdHt9bDgLXeXu/Nx7WNrjp66y93sc+33A5tFAmJixYnomUlH8R9pDTjMxYvDdNP6SaaSimVnCRF8BecB/JFI7B15q/NOuV5sG7a37tLDpRg12jISS+00YhWiSm5Fo13GIElM/wueaLlqQ6at4tu1wZRdZRIhMZZ5IA/rdATR1z/wB1rpH/AKT9Mf7XzYClwAAAAAAAAAAAAAAAACf+sMZW90LtN1jOTFQ4g9uGF9Xy+gqjPdnuczBkvhjzlQqdhIfOc/sOX+gBQAAAT79vXOWUF13WM/A1X9wTrzGSftTxe9i526Tzjxjx9VLYxVP/ABwfz+0BQQAAAAAAAAAAAAAAAABLzdLc2qfdC5N20ciuIXoHS20eYJt4X4NY2Wqz9PblQI6zk3xWsUlkzVHBS+cmb+TZ8FAZcoWsbxKbzT4Zh6rra26+0x1Kj2XeOjK5OPXVjqqDvYrzZ1S1la4XNc+0ht3zUplOJVWJNrOTVVIyv2yRPQfIai0n/wB1ftv/AIG86/8A2xYBUQBLn3bI6Pbc1Vq9oMGSV1om99GylLthGqGLFVn7jY0I0cOoGX+n99FqOWypk1PonLhQufBvPwAVGAAEtnv/AHoYf/8Amwr/APsnKAKkgJo8R/8AM/7lf/URSv8A2yjAHafuRf8AIj1N/wAIrH/koANEaM/3J6d/4Wa+/wBkogB2mAlzqmOj6r7rvSMHWWDKvw1q5W1fdbJFQzVCNj5y3oXh/FJ2aUaNE0UHk7iOcKI5dHLlYxD5xk2fOQHffaO5+f8AXNHgqJvPWVh3ypt6RewdO0NSddI7VvWwncG0LKTDuvU5ys1bqfpRicrtV4Zw3Ozz6DpH+t6MAMpcqcY+1tu2Ib7907zhHYeMrRMQ0/V9jONhuXtEvsK7bO5+m2zVtwt09T4ecgHK6XqaEaKtEklC4QMZA5fIb90z0FQt02TdVPo0dPtj6A2O41Jan0kyiG0G+s8XHt3Ug3qy0ZMySzljE/Ww3W+5RZKprlyT6XjGDZDnm1/91uyv/wAAuX+zsiAgnyNhToVP2yedkMGd0LnfUKvXO30fpqKsXNpaWCbqmi4FyrkxWiUgyn3DqVM3UKsddp8xSkwQxwFB+6/99vtzf9XTX/28toCkgCaPuuf8sFe/6iOef/c2FAUuATR1z/3Wukf+k/TH+182ApcAAAAAAAAAAAAAAAAAn3oPOZP3BfcKmv6xYik8Va49X7CngKbuDYRkfP8ASQm2yn8fswpjP7QFBAABPbjfOIPpH3Q6Mf5MIdi682TEJeMF9Nf2Zw7yThdb048efuL/AFOwm9X4Z/D8cZAUJAAAAAAAAAAAAAAAAASd913Xm9thVvlNrzvGWrOxIzqOpLM7hWK3KWFLWjeWrVnr/wCvrIrHMH6MHWa86lElnT13gjREpcZUN4Ab60Fomjc56zhNZ0RssZqx+rI2CxyZ/urNerfI+lax3m4yp/U5mbPZH+MrOV1TGzjyVMnpSTTIUMmago91jPcs6/vclT7TH0ezab0NF1u5Pq/LNKpYJOHj1SS8dCWJdonESr6LPnw5RQWUUQz8D4KAo2A/lhsvImxNlSyVA2Ly/wBNWHuaU32hNXLsGTmplxzK+1U320rO4eR0wvbj1JOus6SRv9lXEYdtJNnCJDpnJ9PDHIf1PAACb7yjXY3u2xWyC0+0m12n7fqlMUvpa/LZpZLhnoCRmcVQ9pw0/Iy2XMOcrv7HK/3X22cK+j0Z9QCkACQki46C4l6i6V2ey552H0hz10hNU7YGJHRraPse09d2yDhWFVmoZ7rxy6j5GytJH6v1kDtVMJpoIkMZTGcuMJBxXoXfnQvb2p7dzboXizpLWJtnoxdSu20epqTH6cqtHqUq9OvOy0ZHOZ6XkLk9xGxp0cJMs5VbmXKfJDn+iksFg6hXW9PqVXqTRYzhrV67CV1s4OXJDrt4SNbRiKxyZUVyQyqbbBs49RvGc/jn8QGMfcXpe3r3zy3h9TRtvsjRts/XUvuCi67m813YmxdGxsyZbYlJo8yRwyWaT8s1ygf0prpHcNUFkMfVyr9BUMhe3BzxCVDo/ce7NT84bq5e0BK6kqmuahQegfzdjfZO3p2dzP22YjK7Y7NbbJX6wjlkl6SO3y5HLlyddA2CKGRQDaHWmityXC0al3/zXNUFhvrRKF/YV2vbWZzLzXV7quxoiPj7LW5pWvvWMxDyqasM1cRztBRMn1iGSXMVJTKiYT759rfuoawr+3aTDcw6yqe095blvW1bv0zeN4Ued1xGzVvXYxX5hUtM01KRtbNjCwcc3Uj0nqr0yiyRlHiJ/X9rgKmcm83QvLOmonWbGcd2+xO5WXumyL/JI/QldhbKtS5HtsuEillZ0omd+4TIigRRZdVJm3RTOqqcmVDB29sxo6f632CxYtnD169pFraM2bRFRy6dunMC/RbtmzdEp1l3C6x8EIQmMmMbOMYxnOQEr/Zm5svOmOfrBsPcFYsFV2vtqai45xBW+AfVm0V3XOqYotEoMFKQks3ayscpkzR+9JhVNLK7Z2gp6M+cKHDRHZtMuFp2/wAEydZqlkscbTuo21gt0hBQUpLsatAlotnZmm7G7j2rhCDiMO3CaWXLoySP1DlL6vVnGMhv8Bi7v3Q1+6K5ps1G1W8imuyoexUrYVHQnVCIQ8tYKDZ46xt4V85Ux9JriUQZqJIqKZKjhxlP6pyJZOcodDNPcb2VX44kXs726O8GOwmbJv8AnDHV+oGm09fmklGCC5iw2wIuxsG0gxO5UMXJiNlDolx4PjKmDEwHI+Q9f74t3RXQfXu9tbk0rnZVcpGr9XaqezMdP22LolHcSLtxYLk+hnK0W2lJ6TclVTbF8qI4ycmf3ZE1VwpOAAAAAAAAAAAAAAAAAnvxbnE5vz3PL349SEx25WqXDLfDPqhtV8Tch09+jg39r6GwkbBjxj4Fznx+PqAUIAAE8tb5/SPuhdW1w3yMdv8AIHIe14kuflyvZdf7K6k1fsJTGP8AO4b113Si+rHxLk/jPwyUBQ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATz9svP53z3fdon+ZTd/X/b+12qvwzhxVZbrDbte1m4wpj4K4W1RWILPqx8M/wBn5fAChgAAndvHP6F9xzg7YX9yw21qvr/lGSN+CchZJaF1X0/RCqG/AzqJr/Mtw+3L5/u3rjPjPj4BREAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB1D0HteN0NoTd28ZrKWIfTOotk7Wlcrm9KOI3XlNmrc9+qbzj0p/bRBvVnz+ADqvgvVMno3iTknUU9hXNm17zlpytXBZwX0unt2YUGCLdZN4XOC+HsrazPHK3wx+9VN8MANZAACdPuZZ/SWmNR9Cp5yRXlHrTmrecg5x8uY/XrvYjLSm9pXKv4JEiuedx21wfOfBTESyQ2SlNk2AosAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAnT7omf1NzDH6EQzlR91tvnnfltRlj45fUfae3asTehPRj4rEj+dYa3vjp+PChGuSm8FyY2AosAAADp7obTsD0PoPdmgrQbBK5uzU2xNTzi2U/q5bxewqjL1N66TJ5xn6zRCWMqnnGcGKcmM4zjOMZAdT8Fbjnt+cb86bQuOMpbEl9ZwkBtloZT6povdNA+vr3dMKdXOMGUPB7VqswzyY2CmzlDyYpc+S4DXIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJy7jN/Fj3IuQNWJ/4iD5l1Pu/se3pm+dJje7rHZ5W0Imoj8SZPMVXYO1V0lD+PpqQ+PR5MbOSBRoAAAABODjvONRdN95cquf8LGt9rQPZ2o2Z8/TTNrLsFrMyGwEmKef3a6rTrHXGx37v6X9ynONPqFKZYp1Qo+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcHDOf4r7e7l67V8uI3au/j876nf5z6yK6Q4pSmNP4+0Xz/rEbKdMP9pSzRVPwgszlEVE/Vg31DhR8AAAABNrrvOdIdUcUdcoZy0rL64zHEO9nZfJGyev+ppCum0vY5TJv3B1a31TSKjBtFD5Jlq2u0gbBvBzkOFJQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABlDuLes5zjytuHaVMZoy2z0IBnSdJV1fBDEte/tqzkXq7Q9SMmYqmVErLty4QzNXwRTJEVjn9JsFzgBznmDRcLzJztpTn6vvV5aP1DrWpUZSed5OaRtMtCRDZvYLhLqqGOq4m7hP4cyj5U+cnVdu1Dmz5NkB3sAAAAA6H6g0RB9O887i0DYJB1CM9qUKeqzKzR+M/m1NsbloZeoXuDPg5Mo2Gh2tuymI5TGcZTesUj/ALAHBeH99znR/MuuNh3hg1gtuRiU7rHftVaZxhKndCafsUrrHeFYRR9KSqcbHbKqslmOOdNPLmLUbOCl+msTOQ1kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmpuY+ei/cB580A1z97rzj+ufzp7uITP1WTnaltTt+pOQ6NJ/T+RTKKyV6u50DmKo1f1WDcZIYqyZsBSsAAAAAAAEzKvnHLfuK2+kK4+w097ikE42vR84z9OLgux9HU+Mgdv1hFMuPot3u8Oe4GEsrJAhS4Vd0KxO1MmWc+chTMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHENg32o6rod12dsCcZViia6qVivV0skkfKUfAVSpxDyesM0+Uxg2SNIyJYLLKZxjOfQTPjGQGLfbrodtS1JbOk9rwLyu7v7Z2A+6X2BX5cmMTdBqlihoet6C05Jer1HavdQaArdch5JuQ30M2NOUdEKUztTyFAQAAAAAAAZB7j0DZug9BS8TrKQYQG/dYWKt705ntklnJGNa3/AKne5sev/wA2WKchyVK4qJuKzY08Z/xVZnJFvnGSrZwA7C5e6BrHUuhNa72qjCQgmt5g1FJ2oTWMEsevL3AyD2s7H1ha0cFJhtb9ZX6GkoGVSxjGE5CPWLjyXGM5DvwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATG7PNjp3eek/b3if8bTZvMP052cZL52zTmzW9rIbXOpZfOPR6VOnt3wbeNVbZN6X9NrFpROXwYvkKcgAAAAAAAAACXsUb+S7up/XlvMfzT7itkfWOrrG/dwusO76/WjOrhWTKn9DWKiOr9YVj87YJYyVM10qssbPre2FIpgqEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6v3XuLX/PepNi7v2pNFr2vNW1GaulslPpGcuU4qEZqOjtIxgl/iZaclFSkasGKGDOXz1ZJuiU6qhC5DLvBOn7/WKReeht9wxoTp3r+1Ndy7ggHCpXTjVdfLFIwuludGrknlL7DQusUWcU9+jn7Z9aVpqUJjBpJTyG8gAAAAAAAAAB0H09z3VepNH3jStskZWvJ2ZtHSNWvFdOmjbdZbGqcuwtms9q0p2p8jK56zvkLHzcYqbynh4xIVTBkjHIYOrOI+iLXu7XVipu52EXWeqOd7Uppnp6nRZFG0YlsKIjmcjEbKp7Jxgrr+FW9Kc+Y26rrG9fojZTDJU+XjJ4mmGzwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASzvKn89HYjDTzHP5hylwpdqtsDej1PH14LcvZEYjH2/TmkMLFx9tJ13mlm7Y3y0JYMdP9Wuqw1z88fJoFCpgAAAAAAAAAAAACaXZtKuGidiVv3EtIV2Xs1j1fVkqH1pqqrMlZCc37yU0k3k89eV6FblMpObn5rlpJ9aqgknjLqTj3E7ApeVZluZAKB0W80/Z1KqWxtfWSIuNEvlbhbhTbZAPEpCDslYscc3loOciXyGTJO46UjXaayKhc+DEPjIDlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADDvbHQ131pC0fRfPZYqV6/6ckpakaFjZZp+aQVBj4ts1X2X0dsWOIYpjat0HXZFOSeJnyTE1NOIqCSOVzLIGwHd3NfPtH5d0tStKUFSVkIqqtX7qZtNjdfmVw2HebJKPbNsHZ97mMkIebvmybrLPpqYeZwXC8g9VMUpCekhQ70AAAAAAAAAAAAAAEnKsp/8be/mmtZDP2XBHVexnJtPSucfSg+RupNhzK8hJaVkjfBrAaG6QtL9Z/TVc5TaV+8O3MFj0N5mEbtwrGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADpjoPfmuOY9RW/dO1ZJ4xqdRatMFYw0etNWq2WOZftYSo0Ki1tp5kLXf75Z5BpEQkU2wZzIybxFBPHqP5wGauMtD7HZzV56+6hjmTbrDoeMiGUhUWz9GciOZdGw7p1Ka55epculj7V5mtKSKsrcZZrgqdkubx25LnLBtFItg34AAAAAAAAAAAAAAADr7a+qteby1rd9P7ZqkXeNb7GrknU7lVZlI6jCZg5ZAzd03MdE6Lpo5S84VbuUFEnLRwQiyCiaqZDlDBnMe3dhc9bWjeBeqLVLW2xqRUpJ8cdIWk+Mr9RamrLbLl9Qr1M4TRYq9W6VhUylsSGMJntsEmlZGhMnzMt40KaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOO2+31XX9Ust6vNihqhS6bBStotlqsci1h4Ct1yCYryczOTUq+VRZx0XFx7ZRZddU5U0kyZMbOMYATP0HWLP3Xt2odvbjr01W+fNbPHsnwNou2Rj2Hk5FSSYuohx2rt2rSiDd4y2Bd4B6u215Cvkir1OqvVJBwmlMS6qMYFUgAAAAAAAAAAAAAAAAAB0J0pzjrvqbVkjq3YpZmPTxKRFspN5qMjmB2JqfZdVdYk6NtbWFpSSWc1a/0mZIVyxdkKdM+PqN3KS7Ndw3VDOXLfSuxmF/c8Z9iHiIrqyowL6eo+wYiNxXtddkakhFm7M+6tUsTKrNoS7QhXTZK/Uoiqjqryq5XDf68K9j3agUIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHoykpGwkbIzU1IsYiHiGLuUlpaUdt2EbFxrBuo7fSMi+dqJNWTFk1SOossocqaaZcmNnGMZyAkzAM5P3TrlB3+yR8hFe2rryxx1l1ZTJhmswd9736syaUjXtv3mJeJpuU+RKXMsUntQhXJC42DJopTb1PMI3jEZIK6AAAAAAAAAAAAAAAAAAAAAM5dO8w686o1+1p10cT1YslWnmd51JtuiP04LaektoQyLhKu7L1lZjN3WYexxRXSqKyKyTiOlo5w4jpFs7j3TlsqGfucupdhwGyWXHXareAqnUCMXIyGrNmQDJSC092hRq8kU8jsDUKTtw5LV9o19jki1z16s4WkYFQ2XrA7+EUSekChwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPh2ez1ulVyeuFxn4WqVKrREjYLNZ7HKMoSv16BiGir+VmpuYkl20fFxUYxQOs4cLqESRSIYxzYLjOQEo2URa/dUk4+w3KHsFF9syKftpWo69nmUhXLt7gLxg4TdRN02ZBvUmcvUuOE3CRHMPWXiaMjsbwm8lkkIDKTCVCuTdu3Zt0GjRBFq1aopN2zZukRBu3boEKkiggikUqaKKKZcFKUuMFKXGMYx4AeYAAAAAAAAAAAAAAAAAAAAAAdG9D856o6j1s91ft6BcSkNmSjbJW56Fk31avWur1X1TO6psnWN3hlmtioWxKhIZ+4jZaOXRdNz+omcmRUVTOGLqD0ttfka5Vrnvvqebz1StEwwqfPPeacWxrtA2vJSC2Gde1b0owjEW1d0h0c8PlNBm9KVrTr24zjMWaOklfyIgVDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdR7y3vqXm3W05tvdl1i6JRIAzRu4lJArt28k5eUckYwVXrEDFt30/b7lZpNZNnFQ0W1dyko9VTbtUFVjlJkMBV3SW2+/rHA7Y7KpktqvlqvTMfadKcIWIzU8/fJCJdpSNW2328kxcPIuWl2jpBJ/BauSVcwdfXKk5nVJOWTRbRAVYxjBcYKXGClLjGClxjGMYxjHjGMYx8MYxgB+gAAAAAAAAAAAAAAAAAAAAAAAAOKXqiUraFNs2u9j1Ou3uhXOGfV22023Q7CwVmywUmgZtIRE3CyiDmPko94gfJVElUzENj9gCZRK/0X7cXk9Fj9kde8GsfHnWyTiV2B1zyVCEznOcazdP1nli6m0PX2+PCdcdLLbDr7Mn04xewoFQjGgUT09ufVPQOvK9tjSl+rOy9dWpuovCWuqSSMlGuDt1Ttn8e5wT0uYuaiHqZ2z+PdpoPmDtNRBwkksmchQ7NAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYv6Q7SqOkrPEaW15UZ7ovrG6RWZah80azeR5bRmGUWyzT2Btm0v8mrWitMs3vyOrRYTooLGIdvGIScj9JgqHBtI8c26W2TB9SdtXCB3h0xCfeLayqtcayDfnLk9nKt1Wz6G58p04XD2UvDqPXM0l9izqRrTMpZOk2LDxin5SmFCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAABPjb/EMgy2HYukOL9hNuYOlLG4TldgIfkatj506XeM0ipt2nSunGUhDITU+s3Tw2Ru9fcw93j0skKZ+9ZJflqoeTUfd0ce/QHPfXev3PI3Tc85zF1Gs2ueRsGk99v0S5Oo65g33iPg61tBZdAv1zVp+3g72xS8ndwaaBSuFAoGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4XsTY+v9RUqx7J2pd6nrjX1QjlZe1Xe8WCKq1UrsWhkpVH8zPTTplGRzYpzlLgyqpcZObBcec5xjITmPvHqbuT/AMp5GjJ/lvmaQz9KT7S23R/ttu7Fhz+TKKcjc93uNKpHx0o3zj7W/bDYIRpSHw4jK7ONzpuyBsXnHljTHLFYmK/qivPSS9vlsWbZuyrfNSd227uK6HR+g5vG29m2Rw/tl8tDgnkhFXrg6LJv6WrNJs0TSbphogAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB1xtnT+rN8UGf1ZujXtQ2jrq0titZ6mXiBj7FASJEz4VbLqMJJBdJJ8wckKs1cp+hw1cEIqicihCmwGCUdF9k8fmwvypf1er9CsvOf5U+oL/IpbbpUWn4wnGc+9bTLeemphkwb4yVpXdnJTWFjYIinaYhqXBCh31ovuTRm77ctqVdxaNK9FRzBSRneZN/QP8Mt4MGTbBvvJeArz927gtqVBrkvjNkpclZK0fOcYJIGN5xgNhgAAAAAAAAAAAAAAAAAAAAAAAAAAA9CUlIyDjZCampFhDw8SycyMrLSjxvHxsbHskTuHj+QfO1EWrNk0bpmOqqocpEyFyY2cYxnICcr/vSw72cO6v7dupsdPuCuV4190na5h/rfiaoOUVTtnTpruP8AJ5id3+9j1MeorDW0TYmKqpMtnsvEmz9UofZ19wM0sF1rm7u19mPuxt4VeRRsFJYWWvoVLmfR0+mU2Un2heb0JKdrcJOxxjeG1qtD213dLxnCUwiib6BQogAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOkd8c26H6dqSFI35quobQr7B+nMQZLJGlPMVOfQ9OWtno1oZnaWih21jkmMtpaGeMZJsbGMpLkz8QGPiaA7h5nx9bl3oFh03rJj8yHOncU7OubpGsE8+vERrftCqQli2Q3KmkTJUi7Crmw3rhQ+MHlmqRfOA+rE+5ZqOmyLGqdiUXZfBt2du28Y3X6Rio1no6fk11St0EaZ1bS5O084TWZFwoTDNi+sUTYlSqp4Vi0FMmSKFDIyTjZqOYy8PIMZaJk2qD6NlIx2g/jpBk6TKs2eMXrVRVs7auET4MmomYxDlzjOM5xkB7wAAAAAAAAAAAAAAAAAAAADpHeXSnP8AzNW29t6A3HrrUME/c4YQ7i92mKgXdjlTmIRCDqcQ7cFmLbYXaqpCIR8Y3dvXChykTSOY2MZDIWeu+nt/5+y4u5MscbVXefQh0p222tPOurytT/MWXpWhnEQt1Jsw+EcYURQlIKhRL4ihDIzXp9WcB54726ofacowt/ee3rV29Y2LxtKx2s7dDstecf1GTarEctVatynW38hU7UaPckwo0fbEkb/Nsz+coP0sZ9OAo2yZM41m0jo5o2YR7BsgyYsWSCTVmyZtUiINmjRsgQiLds3RIUiaZC4KQuMYxjGMAPZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHz5WJip6Mfws5GR8zDSrRePlImVZtpGMkmDpMyLpk/YPE1mrxo5RPkiiahDEOXOcZxnGQE+ZH2ydC1eRfWTli0bc4Ttj50vIuF+Sbk1pOspCUXUy4PIT/M1vhL3yvYXjh0Yx13TmkmkFvqKY+5Lk+cgPXwT3R9L+CkW5a7mqTT4Yy6/VfGe9sM8fhlRZqjvvSWwrAXP4+lHXrBXGfwRyX5w8uPcgqFH8t+n+a+wOUnSHyPpq+aLmdv6rbKF8ety43dyk93/AKogYdTHk6TmdlYU2SfBVNFXylgNL6X6y5d6ORMtoDovSG6MpYP9021htKlXaQjzo+cOG8pGV6afyMU8amLkqyDlJJZE+MlOUpsZwA0EAAAAAAAAAAADwuHCDRBZ06XRbNm6Si7hw4UIiggikXJ1VlllDFTSSTIXOTGNnGMYx5yAxBevct4SoE+4prrpnXV42E1zkq+qtHuJboncCZ/VkhEzah0JF7I2Xg6yhclTx+VeVD4zgvnOM4AcJz2P0zs/9xzP7fG6ZBmv8jTY/Xtsq3H2tsmUx4SWVqz9vtXqRIqGM+tUjnWbTyXwUqmT+rBA8WedO79z/P0H2tH6Wq7n/WdWcJ6zjqPJKNs/E0VYei96H21f5ghzZ+Z9VoLXz7BcYwQyefVkwdz6P4S5S57si1/19qOJfbcfIZbzG+NmS1j3N0HPJHKoVZKa3ttuYuu137RYyyhstTS+GZMqGwmkQufADXIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJz9esPaclJthHd1KcApW945aIQanTclz/D3gkif04jjVuU2O6ZWljK4+H26jFZNwXPj6ZsAPgU/gPlmdhW1m5d6A6b1fAOceYyR527k3hZ9ZEx4wZPMNri5bG2polqRPBvhhtAFIYvjBsGLguMBy0vKfYlXzjGv/c13PONk/8AVo/obn3lTaLZAuPwQO/1Lqvm6zPm5c/D1OZFZ1nH9Zc2fiA9pGl+6PB+S46N4S2MgTz9FOS493zquTUL/ZK9l4ztfaEaqt/SojFNyZ/Ylj9ofhp33T443pLq32/riQv+fNvvovWplfmx8ftcc3bXwh5L5+H1lPGf2/0h+42F7p6fy55C9v8AefAufqY9xvouN8G+ODF+hn2sZb1Y+GM4z9TH4+PHw85D8/XXuoOfh/K37f0L6s5zk/8APr0XZvpY9WMYL9P/AON2pfXzknnPn1p+M/Dxn+sA8X1vdWlfh+X+3zQ/V8MqfnHR22foef7X0fyPS33Xp/8Ap+oj5/pwA/z/AAk9zOw4ziy9tct0lspjGPttPcJ3NCZa4z/W8WTbPZm0Yh6rj+yfMAgTH7U8gPFniDcNo+bbHuR9vXFFT4L1+iL818/1shM/1kmD/SvO9R2m2KfOc/MranCpcePScvjzkOhdq8sezvpFy1ddiXDTNmkvrtlCOPcX68sm9sOXp1SZbKpRPY+47zBtlDuMlyik1aIopm8YRTJjBcYCkujf5f8A9BR38tX8Hf4X/D8p/gb+iv0F/dk8fl36B/8AT3916f7r+z4/Z4AdxAAAAAAAAAAAAAAAAAAAAAAAAAAAA//Z",
      },
      styles: {
        normal: {
          fontSize: 16,
        },
        normalNo: {
          fontSize: 16,
          bold: true,
        },
        normalCenter: {
          fontSize: 16,
          alignment: "center",
        },
        normalRight: {
          fontSize: 16,
          alignment: "right",
        },
        normalRightBold: {
          fontSize: 16,
          alignment: "right",
          bold: true,
        },
        textBold: {
          fontSize: 16,
          bold: true,
        },
        textBoldCenter: {
          fontSize: 16,
          bold: true,
          alignment: "center",
        },
        textBoldHead: {
          fontSize: 16,
          bold: true,
          alignment: "left",
        },
        smallCenter: {
          fontSize: 14,
          alignment: "center",
        },
        smallCenterBold: {
          fontSize: 14,
          alignment: "center",
          bold: true,
        },
        smallRightBold: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: "center",
        },
        body: {
          fontSize: 14,
        },
        bodycompany: {
          fontSize: 14,
          bold: true,
        },
        anotherStyle: {
          italic: true,
        },
        myCell: {
          fontSize: 16,
          // fillColor: '#BEBEBE',
          alignment: "center",
          // bold: true,
        },
        myCellBold: {
          fontSize: 14,
          // fillColor: '#BEBEBE',
          alignment: "center",
          bold: true,
        },
        myCellSmall: {
          fontSize: 14,
        },
        myCellSmallWhite: {
          fontColor: "#ffffff",
          fontSize: 14,
        },
        myCellDetail: {
          fontSize: 14,
          alignment: "center",
        },
        myCellPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumText: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "left",
          bold: true,
        },
        myCellSumCost: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "right",
          bold: true,
        },
        myCellSumTextCost: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "left",
          bold: true,
        },
        myCellSumTextCostNum: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "right",
          bold: true,
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };
    pdfMake.createPdf(docDefinition).open();
  }

  //picar 9036 no show customer
  printTaxInvoiceNoShowCustomer(isCopy) {
    const {
      company_setting,
      date_receive_thai,
      carBase64Img,
      sealBase64Img,
      tax_invoice_name,
      tax_invoice_address1,
      tax_invoice_address2,
      tax_invoice_tax_id,
      tax_invoice_total,
      tax_invoice_vat,
      tax_invoice_payee,
      car_sell,
      use_old_license,
    } = this.state;
    // let moneyText = ThaiBaht(car_sell_pay.car_sell_pay_count)

    let car_brand_name = car_sell.car_brand_name;
    let car_model_name = car_sell.car_model_name;
    let car_sub_model_name = car_sell.car_sub_model_name;

    let car_name2 =
      car_brand_name + " " + car_model_name + " " + car_sub_model_name;

    if (car_sub_model_name.indexOf(car_model_name) !== -1) {
      // มีชื่อรุ่นใน รุ่นย่อย
      car_name2 = car_brand_name + " " + car_sub_model_name;
    } else if (car_model_name.indexOf(car_brand_name) !== -1) {
      car_name2 = car_model_name + " " + car_sub_model_name;
    }

    let taxInvoicePayee;
    if (tax_invoice_payee === null || tax_invoice_payee === "") {
      taxInvoicePayee = [
        {
          text: "(................................................................)",
          style: "smallCenter",
        },
      ];
    } else {
      taxInvoicePayee = [
        { text: "( " + tax_invoice_payee + " )", style: "smallCenter" },
      ];
    }

    let company_name = company_setting.company_name;
    let company_address = company_setting.company_address;
    let juristic_number = company_setting.juristic_number;
    let company_tel =
      company_setting.company_tel === "" ? "-" : company_setting.company_tel;
    let doc_type = isCopy ? "( สำเนา )" : "( ต้นฉบับ )";

    let tax_invoice_total_text = ThaiBaht(tax_invoice_total);
    let tax_invoice_amount = parseFloat(
      Number(this.state.tax_invoice_amount)
    ).toFixed(2);
    let tax_invoice_no = this.state.tax_invoice_no;
    let tax_invoice_number =
      this.state.tax_invoice_number === null
        ? "-"
        : this.state.tax_invoice_number;

    //let head_line3 = 'โทร. '+ company_tel + ' เลขประจำตัวผู้เสียภาษี '+ juristic_number
    let head_line3 =
      " เลขประจำตัวผู้เสียภาษี " + juristic_number + " เบอร์โทร " + company_tel;

    let invoiceNoRow;
    if (
      tax_invoice_no === null ||
      tax_invoice_no === "" ||
      tax_invoice_no === "-"
    ) {
      invoiceNoRow = [
        { text: "", style: "normalNo", margin: [0, 15, 0, 0] },
        {
          text: "เลขที่ " + tax_invoice_number,
          style: "normalRightBold",
          colSpan: 2,
          margin: [0, 15, 0, 0],
        },
        "",
      ];
    } else {
      // {text: '', style: 'normalCenter'},
      invoiceNoRow = [
        {
          text: "เล่มที่ " + tax_invoice_no,
          style: "normalNo",
          margin: [0, 15, 0, 0],
        },
        {
          text: "เลขที่ " + tax_invoice_number,
          style: "normalRightBold",
          colSpan: 2,
          margin: [0, 15, 0, 0],
        },
        "",
      ];
    }

    let vatPercentText =
      this.state.company_setting === null
        ? "-"
        : String(this.state.company_setting.vat);

    let headerLeft;
    let headerCenter;
    if (Number(port) === 9008) {
      // roddee
      headerLeft = { text: "", style: "normal" };
      // headerLeft = {
      //   image: sealBase64Img, width: 100
      // }
      headerCenter =
        company_name +
        "\n" +
        company_address +
        "\n" +
        "เลขประจำตัวผู้เสียภาษี " +
        juristic_number;
    } else {
      let logo_width = 110;

      if (company_address.length >= 60 || head_line3.length >= 60) {
        logo_width = 100;
      } else if (company_address.length >= 57 || head_line3.length >= 57) {
        logo_width = 96;
      }

      if (port === 9000) {
        logo_width = 80;
      }

      if (port === 9048) {
        logo_width = 215;
      }

      headerLeft = {
        image: carBase64Img,
        width: logo_width,
        margin: [0, 0, 0, 0],
      };
      headerCenter = company_name + "\n" + company_address + "\n" + head_line3;
    }

    let imageEmptySeal = {
      image: "emptySeal",
      width: 80,
      border: [false, false, false, false],
      rowSpan: 3,
    };

    let car_license_new =
      car_sell.car_license_plate_new + " " + car_sell.province_name_new;
    let car_license_old =
      car_sell.car_license_plate_old + " " + car_sell.province_name_old;
    let car_license = use_old_license === 1 ? car_license_old : car_license_new;

    // pageMargins : [left, top, right, bottom]
    let docDefinition = {
      pageOrientation: "portrait",
      pageSize: "A4",
      pageMargins: [35, 40, 35, 0],
      // background: {image: 'book', width: 600},
      content: [
        {
          table: {
            widths: ["15%", "70%", "15%"],
            body: [
              [
                headerLeft,
                {
                  text: headerCenter,
                  style: "textBoldHead",
                  margin: [55, 0, 0, 0],
                  colSpan: 2,
                },
              ],
              [
                { text: "", style: "normalCenter" },
                {
                  text: "ใบกำกับภาษี / ใบเสร็จรับเงิน",
                  style: "textBoldCenter",
                  margin: [0, 20, 0, 0],
                },
                { text: "", style: "normalRight" },
              ],
              [
                { text: " ", style: "normalCenter" },
                { text: doc_type, style: "normalCenter" },
                { text: " ", style: "normalRight" },
              ],
              invoiceNoRow,
              [
                { text: " ", style: "normalCenter" },
                {
                  text: "วันที่ " + date_receive_thai,
                  style: "normalRight",
                  colSpan: 2,
                  margin: [0, 0, 0, 2],
                },
                "",
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          columns: [
            { width: "15%", text: "นามลูกค้า", style: "textBold" },
            { width: "85%", style: "normal", text: tax_invoice_name },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 2, 0, 0],
        },
        {
          columns: [
            { width: "15%", text: "ที่อยู่", style: "textBold" },
            { width: "85%", style: "normal", text: tax_invoice_address1 },
          ],
          columnGap: 0,
          lineHeight: 1,
        },
        {
          columns: [
            { width: "15%", text: "", style: "normal" },
            { width: "85%", style: "normal", text: tax_invoice_address2 },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 0, 0, 0],
        },
        {
          columns: [
            { width: "15%", text: "", style: "normal" },
            {
              width: "85%",
              style: "normal",
              text: "เลขประจำตัวผู้เสียภาษี " + tax_invoice_tax_id,
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 0, 0, 20],
        },
        {
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            headerRows: 1,
            widths: ["14%", "48%", "22%", "16%"],
            // heights: [20, 30],
            body: [
              [
                { text: "จำนวน", style: "myCellBold" },
                { text: "รายการ", style: "myCellBold", colSpan: 2 },
                "",
                { text: "จำนวนเงิน", style: "myCellBold" },
              ],
              [
                {
                  text: "1",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    { width: "25%", text: "ค่ารถยนต์", style: "myCellSmall" },
                    { width: "75%", style: "myCellSmall", text: car_name2 },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                },
                "",
                {
                  text: NumberUtil.addCommas(String(tax_invoice_amount)),
                  style: "myCellPrice",
                },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    { width: "25%", text: "เลขทะเบียน", style: "myCellSmall" },
                    { width: "75%", style: "myCellSmall", text: car_license },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                },
                "",
                { text: "", style: "myCellPrice" },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    {
                      width: "25%",
                      text: "ปี " + car_sell.car_year_name,
                      style: "myCellSmall",
                    },
                    {
                      width: "75%",
                      style: "myCellSmall",
                      text: "สี " + car_sell.car_color_name,
                    },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                },
                "",
                { text: "", style: "myCellPrice" },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    {
                      width: "25%",
                      text: "หมายเลขเครื่อง",
                      style: "myCellSmall",
                    },
                    {
                      width: "75%",
                      style: "myCellSmall",
                      text: car_sell.car_num_engines.toUpperCase(),
                    },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                },
                "",
                { text: "", style: "myCellPrice" },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, false],
                },
                {
                  columns: [
                    { width: "25%", text: "หมายเลขถัง", style: "myCellSmall" },
                    {
                      width: "75%",
                      style: "myCellSmall",
                      text: car_sell.car_number.toUpperCase(),
                    },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                },
                "",
                { text: "", style: "myCellPrice" },
              ],
              [
                {
                  text: "",
                  style: "myCellDetail",
                  border: [true, false, false, true],
                },
                {
                  columns: [
                    { width: "25%", text: "เกียร์รถ", style: "myCellSmall" },
                    {
                      width: "75%",
                      style: "myCellSmall",
                      text: car_sell.car_gear_name,
                    },
                  ],
                  columnGap: 0,
                  lineHeight: 1,
                  colSpan: 2,
                },
                "",
                { text: "", style: "myCellPrice" },
              ],
              [
                {
                  text: "",
                  style: "myCellBold",
                  colSpan: 2,
                  border: [true, false, true, false],
                },
                "",
                { text: "รวมเป็นเงิน", style: "smallRightBold" },
                {
                  text: NumberUtil.addCommas(String(tax_invoice_amount)),
                  style: "myCellPrice",
                },
              ],
              [
                {
                  text: "(" + tax_invoice_total_text + ")",
                  style: "smallCenterBold",
                  colSpan: 2,
                  border: [true, false, false, false],
                },
                "",
                {
                  text: "ภาษีมูลค่าเพิ่ม " + vatPercentText + "%",
                  style: "smallRightBold",
                  border: [true, true, true, true],
                },
                {
                  text: NumberUtil.addCommas(
                    tax_invoice_vat.toFixed(2).toString()
                  ),
                  style: "myCellPrice",
                },
              ],
              [
                {
                  text: "(ตัวอักษร)",
                  style: "smallCenterBold",
                  colSpan: 2,
                  border: [true, false, false, true],
                },
                "",
                {
                  text: "จำนวนเงินรวมทั้งสิ้น",
                  style: "smallRightBold",
                  border: [true, true, true, true],
                },
                {
                  text: NumberUtil.addCommas(
                    tax_invoice_total.toFixed(2).toString()
                  ),
                  style: "myCellPrice",
                },
              ],
              [
                {
                  text: "\n",
                  style: "normalCenter",
                  colSpan: 4,
                  border: [false, false, false, false],
                },
                "",
                "",
                "",
              ],
              [
                {
                  text: "\n",
                  style: "normalCenter",
                  colSpan: 4,
                  border: [false, false, false, false],
                },
                "",
                "",
                "",
              ],
            ],
          },
          columnGap: 0,
        },
        {
          table: {
            widths: ["45%", "5%", "45%"],
            body: [
              [
                {
                  text: "ลงชื่อ............................................................ผู้รับเงิน",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 8, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 8, 0, 0],
                },
                {
                  text: "ลงชื่อ...........................................................ผู้มีอำนาจ/ผู้รับมอบ",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-4, 8, 0, 0],
                },
              ],
              [
                {
                  text: taxInvoicePayee,
                  border: [false, false, false, false],
                  margin: [-6, 2, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 2, 0, 0],
                },
                {
                  text: "(................................................................)",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-47, 2, 0, 0],
                },
              ],
              [
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-22, 2, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [0, 2, 0, 0],
                },
                {
                  text: "",
                  style: "smallCenter",
                  border: [false, false, false, false],
                  margin: [-16, 2, 0, 0],
                },
              ],
            ],
          },
        },
        {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  text: "หมายเหตุ : ใบเสร็จรับเงินจะสมบูรณ์เมื่อมีลายเซ็นต์ของผู้รับเงิน",
                  style: "smallLeft",
                  border: [false, false, false, false],
                  margin: [0, 30, 0, 0],
                },
              ],
              [
                {
                  text: "เงื่อนไข : 1. ใบเสร็จรับเงินฉบับนี้จะสมบูรณ์ต่อเมื่อทางบริษัทได้รับเงินครบถ้วนแล้ว",
                  style: "smallLeft",
                  border: [false, false, false, false],
                  margin: [0, 1, 0, 0],
                },
              ],
              [
                {
                  text: "2. กรณีชำระด้วยเงินสดหรือดราฟต์ โปรดสั่งจ่ายในนามบริษัท พี.ไอ.ควอลิตี้คาร์ จำกัด",
                  style: "smallLeft",
                  border: [false, false, false, false],
                  margin: [31, 1, 0, 0],
                },
              ],
            ],
          },
        },
      ],
      images: {
        emptySeal:
          "data:image/png;base64,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",
      },
      styles: {
        normal: {
          fontSize: 16,
        },
        normalNo: {
          fontSize: 16,
          bold: true,
        },
        normalCenter: {
          fontSize: 16,
          alignment: "center",
        },
        normalRight: {
          fontSize: 16,
          alignment: "right",
        },
        normalRightBold: {
          fontSize: 16,
          alignment: "right",
          bold: true,
        },
        textBold: {
          fontSize: 16,
          bold: true,
        },
        textBoldCenter: {
          fontSize: 16,
          bold: true,
          alignment: "center",
        },
        textBoldHead: {
          fontSize: 15,
          bold: true,
          alignment: "left",
        },
        smallCenter: {
          fontSize: 14,
          alignment: "center",
        },
        smallCenterBold: {
          fontSize: 14,
          alignment: "center",
          bold: true,
        },
        smallRightBold: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: "center",
        },
        body: {
          fontSize: 14,
        },
        bodycompany: {
          fontSize: 14,
          bold: true,
        },
        anotherStyle: {
          italic: true,
        },
        myCell: {
          fontSize: 16,
          // fillColor: '#BEBEBE',
          alignment: "center",
          // bold: true,
        },
        myCellBold: {
          fontSize: 14,
          // fillColor: '#BEBEBE',
          alignment: "center",
          bold: true,
        },
        myCellSmall: {
          fontSize: 14,
        },
        myCellSmallWhite: {
          fontColor: "#ffffff",
          fontSize: 14,
        },
        myCellDetail: {
          fontSize: 14,
          alignment: "center",
        },
        myCellPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumPrice: {
          fontSize: 14,
          alignment: "right",
          bold: true,
        },
        myCellSumText: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "left",
          bold: true,
        },
        myCellSumCost: {
          fontSize: 14,
          fillColor: "#D3D3D3",
          alignment: "right",
          bold: true,
        },
        myCellSumTextCost: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "left",
          bold: true,
        },
        myCellSumTextCostNum: {
          fontSize: 14,
          fillColor: "#FF9933",
          alignment: "right",
          bold: true,
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
      smallLeft: {
        fontSize: 14,
        alignment: "left",
      },
    };
    pdfMake.createPdf(docDefinition).open();
  }

  handleDateReceive(date) {
    let tax_invoice_date = moment(date).format("YYYY-MM-DD");
    let date_receive_thai = DateUtil.convertLongDateThai(tax_invoice_date);

    this.setState({
      startDateInvoice: date,
      isOpenDateInvoice: false,
      tax_invoice_date: tax_invoice_date,
      date_receive_thai: date_receive_thai,
    });
  }

  saveTaxInvoice() {
    const {
      car_sell_id,
      //
      customer_type,
      tax_invoice_no,
      tax_invoice_number,
      tax_invoice_date,
      tax_invoice_vat,
      tax_invoice_amount,
      tax_invoice_total,
      //
      tax_customer_id,
      tax_invoice_name,
      tax_invoice_address1,
      tax_invoice_address2,
      tax_invoice_tax_id,
      tax_invoice_payee,
      //
      gearbox_warranty,
      gearbox_amount,
      debt_insurance_amount,
      code_item,
      isExist,
      use_old_license,
      tax_invoice_number_current,
    } = this.state;

    let doc_config = this.state.doc_config;

    if (PORT === 9021) {
      if (doc_config === "manual" && tax_invoice_number === "") {
        AlertWarning("กรุณากรอก เลขที่");
        return;
      }
    } else {
      if (
        doc_config === "manual" &&
        (tax_invoice_no === "" || tax_invoice_number === "")
      ) {
        AlertWarning("กรุณากรอก เล่มที่ เลขที่");
        return;
      }
    }

    if (tax_customer_id === "") {
      AlertWarning("กรุณาเลือกลูกค้า");
      return;
    }

    if (tax_invoice_tax_id === "") {
      AlertWarning("กรุณากรอกเลขประจำตัวผู้เสียภาษี");
      return;
    }

    if (tax_invoice_payee === "") {
      AlertWarning("กรุณากรอกผู้รับเงิน");
      return;
    }

    let company_setting = this.state.company_setting;
    let doc_type = this.state.doc_type;

    let is_vat = this.state.is_vat;
    let include_vat = this.state.include_vat;
    let vat = is_vat === 1 ? company_setting.vat : 0;

    let vat_bath = tax_invoice_vat;
    // tax_invoice_total
    // let isExist = this.state.isExist
    let check_doc_no = this.state.check_doc_no;
    // let tax_invoice_number_current = this.state.tax_invoice_number_current
    // console.log('isExist=', isExist)
    // console.log('check_doc_no=', check_doc_no)
    // console.log('tax_invoice_number=', tax_invoice_number)
    // console.log('tax_invoice_number_current=', tax_invoice_number_current)

    if (isExist === false) {
      // add new
      if (check_doc_no === "repeat") {
        AlertError("เลขที่เอกสารซ้ำ กรุณาแก้ไข");
        return;
      }
    } else if (
      isExist === true &&
      tax_invoice_number !== tax_invoice_number_current
    ) {
      // แก้ไข แล้วไม่ใช่เลขเดิม
      if (check_doc_no === "repeat") {
        AlertError("เลขที่เอกสารซ้ำ กรุณาแก้ไข");
        return;
      }
    }

    let data = {
      car_sell_id,
      customer_type,
      tax_invoice_date,
      tax_invoice_vat,
      tax_invoice_amount,
      tax_invoice_total,
      tax_customer_id,
      tax_invoice_name,
      tax_invoice_address1,
      tax_invoice_address2,
      tax_invoice_tax_id,
      tax_invoice_payee,
      tax_invoice_no,
      tax_invoice_number,
      //ber1
      gearbox_warranty,
      gearbox_amount,
      debt_insurance_amount,
      //thadyon
      code_item,
      // auto doc_no
      doc_type: doc_type,
      doc_config: doc_config,
      isExist: isExist,
      use_old_license,
      tax_invoice_number_current,
    };

    this.setState(
      {
        isLoading: true,
      },
      () => {
        axios
          .post(APIURL + "/car_sell/taxinvoice", data)
          .then((res) => {
            if (res.status === 200) {
              // TODx: check doc_no before add check ที่ api
              let result = res.data;

              if (result === "repeat") {
                AlertError(
                  "เลขใบกำกับ " +
                    tax_invoice_number +
                    " มีการใช้งานแล้วกรุณาตรวจสอบ"
                );
                this.setState({ isLoading: false });
              } else if (result === "success") {
                AlertSuccess("บันทึกข้อมูลเรียบร้อยแล้ว");
                window.location.reload(true);
              }

              /*this.setState({
               isLoading: false,
               isExist: true,
             },  async () => {
                await this.loadCarSellById(car_sell_id, true);
              // this.props.onReloadCarSell(null, true);
             })*/
            }
          })
          .catch((error) => {
            console.log("error:", error);
          });
      }
    );
  }

  calInvoice() {
    let tax_invoice_amount = Number(this.state.tax_invoice_amount);

    if (tax_invoice_amount === 0) {
      return;
    }

    let vatPercent = Number(this.state.company_setting.vat / 100.0);
    let is_integer = Number.isInteger(tax_invoice_amount);
    let tax_invoice_vat = tax_invoice_amount.toFixed(2) * vatPercent.toFixed(2);
    // console.log('tax_invoice_vat=', tax_invoice_vat)
    // let tax_invoice_vat_fix = tax_invoice_vat.toFixed(2)
    // let tax_invoice_vat_fix = floor2Digit(tax_invoice_vat, -2);
    let tax_invoice_vat_fix = 0;
    // console.log('tax_invoice_vat_fix=', tax_invoice_vat_fix)
    if (PORT === 9021) {
      // ตัดหลักที่ 3 ทิ่งแม่จะเกิน 5 เช่น 0.467 ===> 0.46
      const floor2Digit = (value, exp) =>
        NumberUtil.decimalAdjust("floor", value, exp);
      tax_invoice_vat_fix = floor2Digit(tax_invoice_vat, -2);
    } else {
      tax_invoice_vat_fix = tax_invoice_vat.toFixed(2);
    }

    // const floor2Digit = (value, exp) => NumberUtil.decimalAdjust("floor", value, exp);
    // let tax_invoice_vat_fix = floor2Digit(tax_invoice_vat, -2);

    // const xx = floor10(tax_invoice_vat, -2);
    // console.log('xx=', xx)

    if (is_integer === true) {
      // คำนวณปกติ
      // console.log('จำนวนเต็ม tax_invoice_amount=', tax_invoice_amount, typeof tax_invoice_amount)
      let tax_invoice_total =
        Number(tax_invoice_amount) + Number(tax_invoice_vat_fix);

      this.setState({
        tax_invoice_vat: Number(tax_invoice_vat_fix),
        tax_invoice_total: Number(tax_invoice_total),
      });
    } else {
      let tax_invoice_total =
        Number(tax_invoice_amount) + Number(tax_invoice_vat_fix);
      let tax_invoice_total_text = String(tax_invoice_total);
      let arrTotalText = tax_invoice_total_text.split(".");

      if (arrTotalText.length === 2) {
        let digit = arrTotalText[1];
        if (Number(digit) === 99) {
          // ทัดยนต์
          let tax_invoice_total_int = Math.ceil(tax_invoice_total);
          let amount_vat = tax_invoice_total_int - tax_invoice_amount;
          let amount_vat_fix = Number(amount_vat).toFixed(2);
          this.setState({
            tax_invoice_vat: Number(amount_vat_fix),
            tax_invoice_total: Number(tax_invoice_total_int),
          });
        } else if (digit === "01") {
          // scauto
          // console.log(digit, typeof digit)
          let tax_invoice_total_int = Math.floor(tax_invoice_total);
          let amount_vat = tax_invoice_total_int - tax_invoice_amount;
          let amount_vat_fix = Number(amount_vat).toFixed(2);
          this.setState({
            tax_invoice_vat: Number(amount_vat_fix),
            tax_invoice_total: Number(tax_invoice_total_int),
          });
        } else {
          this.setState({
            tax_invoice_vat: Number(tax_invoice_vat_fix),
            tax_invoice_total: Number(tax_invoice_total),
          });
        }
      } else {
        this.setState({
          tax_invoice_vat: Number(tax_invoice_vat_fix),
          tax_invoice_total: Number(tax_invoice_total),
        });
      }
    }
  }

  cancelTaxInvoice(action) {
    const { car_sell_id, tax_invoice_number, tax_invoice_status } = this.state;

    let uri = APIURL + "/car_sell/cancel_taxinvoice/" + car_sell_id;
    let data = {
      car_sell_id: car_sell_id,
      tax_invoice_number: tax_invoice_number,
      tax_invoice_status: tax_invoice_status,
      action: action,
    };

    let title = "";
    if (action === "cancel") {
      title = "ต้องการยกเลิกใบกำกับ " + tax_invoice_number + " ใช่หรือไม่?";
    } else if (action === "reuse") {
      title = "ต้องการใช้งานใบกำกับ " + tax_invoice_number + " ใช่หรือไม่?";
    }

    Swal.fire({
      title: title,
      icon: "warning",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "ตกลง",
      cancelButtonText: "ยกเลิก",
    })
      .then((result) => {
        if (result.value) {
          axios
            .put(uri, data)
            .then(async (res) => {
              let results = res.data;

              if (res.status === 200 && results === "success") {
                if (action === "cancel") {
                  AlertSuccess("ยกเลิกใบกำกับเรียบร้อยแล้ว");
                } else {
                  AlertSuccess("ใบกำกับเปิดใช้งานเรียบร้อยแล้ว");
                }

                await this.loadCarSellById(car_sell_id, true);
              } else if (results === "already") {
                AlertSuccess(
                  "ใบกำกับ " + tax_invoice_number + " ถูกยกเลิกไปแล้ว"
                );
              }
            })
            .catch((err) => {
              console.log("err:", err);
            });
        }
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  async checkTaxInvoiceNumberRepeat() {
    let doc_no = this.state.tax_invoice_number;
    let tax_invoice_number_current = this.state.tax_invoice_number_current;
    // tax_invoice_number_current === null คือ add new
    // tax_invoice_number_current !== null คือ รหัสปัจจุบันใน db
    // console.log('new doc_no=', doc_no)
    // console.log('current doc_no=', tax_invoice_number_current)

    if (doc_no === "") {
      return;
    }

    // เลขใบกำกับใบเดิม
    if (
      tax_invoice_number_current !== null &&
      doc_no === tax_invoice_number_current
    ) {
      console.log("เลขใบกำกับใบเดิม no change");
      return;
    }

    // เปลี่ยนเลขใบกำกับ
    let data = await checkDocNo(doc_no);
    // console.log('checkDocNo =', data)

    this.setState({
      check_doc_no: data,
    });
  }

  genNetTotal() {
    //TODO : genNetTotal
    //this.state.company_setting !== null? NumberUtil.addCommas((this.state.tax_invoice_total).toFixed(2).toString()): this.state.tax_invoice_amount
    if (
      this.state.company_setting !== null &&
      this.state.car_sell_type_id === 2
    ) {
      return NumberUtil.addCommas(
        this.state.tax_invoice_total.toFixed(2).toString()
      );
    } else {
      return (
        <NumberFormat
          className="form-control text-right"
          thousandSeparator={true}
          decimalScale={2}
          fixedDecimalScale
          //prefix={'฿'}
          //placeholder="กรอกค่าโอน"
          min={0}
          max={1000000000}
          step={1000}
          size={10}
          allowNegative={false}
          value={this.state.tax_invoice_total}
          onValueChange={(values) => {
            const { value } = values;
            this.setState({ tax_invoice_total: Number(value) }, () => {
              this.calPriceBeforeVat();
            });
          }}
        />
      );
    }
  }

  calPriceBeforeVat() {
    let vatBeforePercent =
      this.state.company_setting.vat / (100 + this.state.company_setting.vat);
    let tax_invoice_total = this.state.tax_invoice_total;
    let tax_invoice_vat_before = tax_invoice_total * vatBeforePercent;
    let tax_invoice_vat = Number(tax_invoice_vat_before.toFixed(2));
    let tax_invoice_amount = tax_invoice_total - tax_invoice_vat;
    this.setState({
      tax_invoice_amount: tax_invoice_amount,
      tax_invoice_vat: tax_invoice_vat,
    });
  }

  genCarPrice() {
    let tax_invoice_amount = this.state.tax_invoice_amount;
    let gearbox_amount = this.state.gearbox_amount;
    let debt_insurance_amount = this.state.debt_insurance_amount;
    let car_sell_type_id = this.state.car_sell_type_id;
    let tax_invoice_total = this.state.tax_invoice_total;
    if (
      PORT === 9035 &&
      this.state.company_setting !== null &&
      Object.keys(this.state.car_sell).length !== 0
    ) {
      return NumberUtil.addCommas(
        String(tax_invoice_amount - gearbox_amount - debt_insurance_amount)
      );
    } else {
      if (car_sell_type_id === 2) {
        return this.state.company_setting !== null &&
          Object.keys(this.state.car_sell).length !== 0
          ? NumberUtil.addCommas(String(tax_invoice_amount))
          : this.state.tax_invoice_amount;
      } else if (car_sell_type_id === 1) {
        return this.state.company_setting !== null &&
          Object.keys(this.state.car_sell).length !== 0
          ? NumberUtil.addCommas(String(tax_invoice_total))
          : this.state.tax_invoice_total;
      }
    }
  }

  genSellNameBuy() {
    let car_sell_type_id = this.state.car_sell_type_id;
    if (port === 9039 || port === 9036) {
      return "";
    } else if (port === 9048 && car_sell_type_id === 1) {
      //TODO : car_sell_type_id === 1 ซื้อเงินสดลูกค้าทั่วไป
      return "";
    } else {
      return "ผู้ซื้อ";
    }
  }

  genSellNameBuyDetail() {
    let car_sell_type_id = this.state.car_sell_type_id;
    if (port === 9039 || port === 9036) {
      return "";
    } else if (port === 9048 && car_sell_type_id === 1) {
      //TODO : car_sell_type_id === 1 ซื้อเงินสดลูกค้าทั่วไป
      return "";
    } else {
      return (
        this.state.car_sell.customer_name +
        " " +
        this.state.car_sell.customer_lastname
      );
    }
  }

  render() {
    const { company_setting, is_vat, doc_config, car_sell, use_old_license } =
      this.state;

    /*if (company_setting !== null && is_vat === 1 ) {
      AlertWarning('ไม่ได้เปิดการตั้งค่า ใช้งาน vat กรุณาติดต่อผู้ดูแลระบบ');
      let target = '#/sales/list';
      // this.props.history.push(target);
      // window.location.href = target;
      window.location.href = target;

      /!*setTimeout(() => {
        // let target = '/sales/list'
        window.location.href = target;
      } , 2500)*!/

      return (
        <div>Loading...</div>
      )
    }*/

    let vatPercent =
      this.state.company_setting === null
        ? "-"
        : this.state.company_setting.vat;

    let tax_invoice_amount = parseFloat(
      Number(this.state.tax_invoice_amount)
    ).toFixed(2);

    let logoWidth = 128;

    if (port === 9008) {
      logoWidth = 142;
    }

    let gearbox_amount = parseFloat(
      Number(this.state.gearbox_amount)
    ).toFixed();
    let debt_insurance_amount = parseFloat(
      Number(this.state.debt_insurance_amount)
    ).toFixed();

    let car_license = "";
    if (Object.keys(car_sell).length > 0) {
      let car_license_new =
        car_sell.car_license_plate_new + " " + car_sell.province_name_new;
      let car_license_old =
        car_sell.car_license_plate_old + " " + car_sell.province_name_old;
      car_license = use_old_license === 1 ? car_license_old : car_license_new;
    }

    return (
      <div className="row">
        <div className="col-12">
          <div className="card">
            {this.state.isFinanceModal && (
              <FinanceModal
                isFinanceModal={this.state.isFinanceModal}
                toggleCustomerFinanceModal={this.toggleCustomerFinanceModal}
                username={this.state.user.user}
              />
            )}

            {this.state.isGeneralModal && (
              <CustomerModal
                isFinanceModal={this.state.isGeneralModal}
                toggleCustomerFinanceModal={this.toggleCustomerGeneralModal}
              />
            )}

            <Loading isLoading={this.state.isLoading} />

            <div className="card-header">
              <strong className="text-title">
                ออกใบเสร็จ/ใบกำกับ (ไฟแนนซ์)
              </strong>
            </div>

            <div
              className="card-block"
              style={{ paddingLeft: 80, paddingRight: 80, paddingTop: 60 }}
            >
              {company_setting !== null && is_vat === 0 ? (
                <>
                  <div className="row">
                    <div className="col-12 text-danger text-center">
                      ไม่ได้เปิดการตั้งค่า ใช้งาน vat กรุณาติดต่อผู้ดูแลระบบ
                    </div>
                  </div>
                </>
              ) : null}
              <div className="row" style={{ lineHeight: 2.0 }}>
                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <td width={"22%"} style={styles.tdContentCenter}>
                        {this.state.company_setting !== null ? (
                          <img
                            src={
                              port === 9008
                                ? this.state.company_setting.company_seal
                                : this.state.company_setting.logo_image
                            }
                            width={logoWidth}
                            alt="logo"
                          />
                        ) : null}
                      </td>
                      <td style={styles.tdContentCenter}>
                        {this.state.company_setting !== null ? (
                          <>
                            <div className="text-center">
                              {this.state.company_setting.company_name}
                              <br />
                              {this.state.company_setting.company_address}
                              <br />
                              หมายเลขผู้เสียภาษี{" "}
                              {this.state.company_setting.juristic_number}{" "}
                              &nbsp; &nbsp; โทร.{" "}
                              {this.state.company_setting.company_tel}
                            </div>
                          </>
                        ) : null}
                      </td>
                      <td width={"22%"}>&nbsp;</td>
                    </tr>

                    <tr>
                      <td style={styles.tdContentLeft}>
                        <div
                          className={
                            PORT === 9021 ? "hidden" : "form-inline mt-4 mb-4"
                          }
                        >
                          เล่มที่
                          <input
                            className="form-control ml-4"
                            style={styles.inputDataNo}
                            value={this.state.tax_invoice_no || ""}
                            onChange={(e) => {
                              this.setState({
                                tax_invoice_no: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </td>
                      <td>&nbsp;</td>
                      <td style={styles.tdContentRight}>
                        <div
                          className="form-inline mt-4 mb-4"
                          style={{ justifyContent: "right" }}
                        >
                          เลขที่ &nbsp;{" "}
                          {this.state.check_doc_no === "repeat"
                            ? "( ซ้ำ )"
                            : ""}
                          {is_vat === 1 && doc_config === "manual" ? (
                            <input
                              className="form-control ml-4"
                              style={{
                                ...styles.inputDataNum,
                                borderColor: setInputStyleDocNo(
                                  this.state.check_doc_no
                                ),
                              }}
                              //style={styles.inputDataNum}
                              value={this.state.tax_invoice_number || ""}
                              onChange={(e) => {
                                // && this.state.isExist === false
                                this.setState({
                                  tax_invoice_number: e.target.value,
                                  check_doc_no: "noset",
                                });
                              }}
                              onBlur={(e) => {
                                let val = e.target.value;
                                let doc_no = this.state.tax_invoice_number;
                                if (val !== "") {
                                  if (val !== doc_no) {
                                    this.setState(
                                      {
                                        tax_invoice_number: val,
                                      },
                                      () => this.checkTaxInvoiceNumberRepeat()
                                    );
                                  } else {
                                    this.checkTaxInvoiceNumberRepeat();
                                  }
                                }
                              }}
                            />
                          ) : (
                            /*<input className="form-control ml-4"
                                             style={{borderColor: this.checkCarSellTaxInvoiceRepeat(this.state.repeat_tax_invoice_number)}}
                                             //style={styles.inputDataNum}
                                             value={this.state.tax_invoice_number}
                                             onChange={(e) => {
                                               this.setState({
                                                 repeat_tax_invoice_number: 'noset',
                                                 repeat_tax_invoice_number_text: '',
                                                 tax_invoice_number_repeat: e.target.value
                                               })
                                             }}
                                             onBlur={(e) => {
                                               this.checkTaxInvoiceNumberRepeat();
                                             }}

                                      />*/
                            <input
                              className="form-control ml-4"
                              style={styles.inputDataNum}
                              value={this.state.tax_invoice_number || ""}
                              placeholder="สร้างอัตโนมัติ"
                              onChange={(e) => {
                                /*this.setState({
                                               tax_invoice_number: e.target.value
                                             })*/
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>&nbsp;</td>
                      <td style={styles.tdContentCenter}>
                        {" "}
                        {this.state.company_setting !== null ? (
                          <>
                            {this.state.company_setting.is_vat === 1
                              ? "ใบเสร็จรับเงิน / ใบกำกับภาษี"
                              : "ใบเสร็จรับเงิน"}

                            {this.state.tax_invoice_status === "cancel" ? (
                              <span className="text-danger"> (ยกเลิก) </span>
                            ) : null}
                          </>
                        ) : null}
                      </td>

                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td style={styles.tdContentCenter}>
                        ( ต้นฉบับ - สำเนา )
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="row">
                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <td width={"40%"}>&nbsp;</td>
                      <td width={"30%"}>&nbsp;</td>
                      <td>
                        <div className="row">
                          วันที่ &nbsp;
                          <input
                            readOnly={true}
                            className="form-control"
                            style={{ width: 152 }}
                            value={
                              this.state.date_receive_thai === null
                                ? ""
                                : this.state.date_receive_thai
                            }
                          />
                          <button
                            type="button"
                            className="btn btn-primary ml-1"
                            onClick={(e) => {
                              this.setState({
                                isOpenDateInvoice: true,
                              });
                            }}
                          >
                            <i className="icon-calendar" />
                          </button>
                          {this.state.isOpenDateInvoice && (
                            <DatePicker
                              selected={this.state.startDateInvoice}
                              onChange={this.handleDateReceive}
                              dateFormat="yyyy-MM-dd"
                              inline
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="row" style={{ lineHeight: 2.0 }}>
                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <td width={"10%"} />
                      <td>
                        <div className="mb-1 form-inline">
                          <input
                            className="mr-2"
                            type="radio"
                            name="customer_type"
                            id="customer_type1"
                            value="finance"
                            onClick={(e) => {
                              // let val = e.target.value
                            }}
                            checked={this.state.customer_type === "finance"}
                            onChange={(e) => {
                              let val = e.target.value;
                              this.setState({
                                customer_type: val,
                              });
                            }}
                          />
                          <label id="customer_type1" className="mr-5">
                            ไฟแนนซ์
                          </label>

                          <input
                            className="mr-2"
                            type="radio"
                            name="customer_type"
                            id="customer_type2"
                            value="customer"
                            onClick={(e) => {
                              // let val = e.target.value
                            }}
                            checked={this.state.customer_type === "customer"}
                            onChange={(e) => {
                              let val = e.target.value;
                              this.setState({
                                customer_type: val,
                              });
                            }}
                          />

                          <label id="customer_type2" className="mr-5">
                            ลูกค้าทั่วไป{" "}
                          </label>
                          {/*<input className="mr-2"
                                   type="radio"
                                   name="customer_type"
                                   id="customer_type"
                                   value="customer"
                                   defaultValue={'customer'}
                                   checked={ this.state.customer_type === 'customer'}
                                   onClick={(e) => {
                                     let val = e.target.value
                                     this.setState({
                                       customer_type: val
                                     })
                                   }}
                            />
                            <label id="customer_type">ลูกค้าทั่วไป {this.state.customer_type }</label>*/}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td width={"15%"}>
                        <span className="mb-3">นามลูกค้า</span>
                        <button
                          className="btn btn-sm btn-primary ml-3"
                          name="customer_finance_find"
                          type="button"
                          style={styles.buttonHeight}
                          onClick={() => {
                            let customer_type = this.state.customer_type;
                            if (customer_type === "finance") {
                              this.toggleCustomerFinanceModal(true, null);
                            } else if (customer_type === "customer") {
                              this.toggleCustomerGeneralModal(true, null);
                            }
                          }}
                        >
                          <i className="icon-magnifier" />
                        </button>
                      </td>

                      <td>
                        <input
                          type="text"
                          style={styles.inputData}
                          className="form-control mb-2"
                          placeholder=""
                          value={this.state.tax_invoice_name || ""}
                          onChange={(e) => {
                            let val = e.target.value;
                            this.setState({
                              tax_invoice_name: val,
                            });
                          }}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td width={"10%"}>ที่อยู่</td>
                      <td>
                        <input
                          type="text"
                          style={styles.inputData}
                          className="form-control mb-2"
                          placeholder=""
                          value={this.state.tax_invoice_address1 || ""}
                          onChange={(e) => {
                            let val = e.target.value;
                            this.setState({
                              tax_invoice_address1: val,
                            });
                          }}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td width={"10%"} />
                      <td>
                        <input
                          type="text"
                          style={styles.inputData}
                          className="form-control mb-2"
                          placeholder=""
                          value={this.state.tax_invoice_address2 || ""}
                          onChange={(e) => {
                            let val = e.target.value;
                            this.setState({
                              tax_invoice_address2: val,
                            });
                          }}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td width={"18%"}>เลขประจำตัวผู้เสียภาษี</td>
                      <td>
                        <input
                          type="text"
                          style={styles.inputData}
                          className="form-control mb-2"
                          placeholder=""
                          value={this.state.tax_invoice_tax_id || ""}
                          onChange={(e) => {
                            let val = e.target.value;
                            this.setState({
                              tax_invoice_tax_id: val,
                            });
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {port === 9039 || port === 9038 ? (
                <div className="row mt-5">
                  <table style={styles.table}>
                    <tbody>
                      <tr>
                        <td width={"18%"}>รหัสสินค้า</td>
                        <td>
                          <input
                            type="text"
                            style={styles.inputData}
                            className="form-control mb-2"
                            placeholder=""
                            value={this.state.code_item}
                            onChange={(e) => {
                              // กรอกมาจากหน้าข้อมูลรถแล้ว
                              /*let val = e.target.value;
                                   this.setState({
                                     code_item: val
                                   });*/
                            }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ) : null}

              <div className="row mt-4" style={styles.tablePd}>
                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <th style={styles.tableTh} width={"13%"}>
                        จำนวน
                      </th>
                      <th style={styles.tableTh} width={"68%"}>
                        รายการ
                      </th>
                      <th style={styles.tableTh} width={"20%"}>
                        จำนวนเงิน
                      </th>
                    </tr>

                    <tr>
                      <td style={styles.tableTdLeft}>1</td>
                      <td style={styles.tableTdCenter}>
                        <table style={styles.table}>
                          <tbody>
                            <tr>
                              <td width={"30%"}>ค่ารถยนต์</td>

                              {port === 9048 ? (
                                <td>{this.state.car_sell.car_brand_name}</td>
                              ) : (
                                <td>
                                  {this.state.car_sell.car_brand_name}{" "}
                                  {this.state.car_sell.car_model_name}{" "}
                                  {this.state.car_sell.car_sub_model_name}
                                </td>
                              )}
                            </tr>

                            <tr>
                              <td width={"30%"}>
                                ปี {this.state.car_sell.car_year_name}
                              </td>

                              <td>สี {this.state.car_sell.car_color_name}</td>
                            </tr>

                            <tr>
                              <td width={"30%"}>เลขตัวถัง</td>

                              <td>
                                {this.state.car_sell.car_number === undefined
                                  ? "-"
                                  : this.state.car_sell.car_number.toUpperCase()}
                              </td>
                            </tr>

                            <tr>
                              <td width={"30%"}>เลขเครื่องยนต์</td>

                              <td>
                                {this.state.car_sell.car_num_engines ===
                                undefined
                                  ? "-"
                                  : this.state.car_sell.car_num_engines.toUpperCase()}
                              </td>
                            </tr>

                            <tr>
                              <td width={"30%"}>ทะเบียน</td>

                              <td>{car_license}</td>
                            </tr>

                            {port === 9035 &&
                            Number(this.state.gearbox_amount) > 0 ? (
                              <tr>
                                <td width={"30%"}>ประกันเครื่องเกียร์</td>

                                <td></td>
                              </tr>
                            ) : null}
                            {port === 9035 &&
                            Number(this.state.debt_insurance_amount) > 0 ? (
                              <tr>
                                <td width={"30%"}>ประกันภาระหนี้</td>

                                <td></td>
                              </tr>
                            ) : null}

                            <tr>
                              <td width={"30%"}>
                                {/*{port === 9039 || port === 9036 ? '' : 'ผู้ซื้อ'}*/}
                                {this.genSellNameBuy()}
                              </td>

                              <td>
                                {this.genSellNameBuyDetail()}
                                {/*{port === 9039 || port === 9036 ? '' : this.state.car_sell.customer_name + ' ' + this.state.car_sell.customer_lastname}*/}
                                {/*{this.state.car_sell.customer_name} &nbsp; {this.state.car_sell.customer_lastname}*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>

                      <td style={styles.tableTdRigth}>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td style={styles.tableTdRigthInner}>
                                {this.genCarPrice()}
                                {/*{port === 9035 ?
                                this.state.company_setting !== null && Object.keys(this.state.car_sell).length !== 0 ?
                                    NumberUtil.addCommas(String(tax_invoice_amount-gearbox_amount-debt_insurance_amount))
                                  :
                                    this.state.tax_invoice_amount

                                  :
                                      this.state.company_setting !== null && Object.keys(this.state.car_sell).length !== 0 ?
                                      NumberUtil.addCommas(String(tax_invoice_amount))
                                  :
                                      this.state.tax_invoice_amount
                              }*/}

                                {/* {
                                this.state.company_setting !== null && Object.keys(this.state.car_sell).length !== 0 ?
                                    NumberUtil.addCommas(String(tax_invoice_amount-gearbox_amount-debt_insurance_amount))
                                    :
                                    this.state.tax_invoice_amount
                              }*/}
                              </td>
                            </tr>
                            <tr>
                              <td>&nbsp;</td>
                            </tr>
                            <tr>
                              <td>&nbsp;</td>
                            </tr>
                            <tr>
                              <td>&nbsp;</td>
                            </tr>
                            <tr>
                              <td>&nbsp;</td>
                            </tr>
                            {port === 9035 &&
                            Number(this.state.gearbox_amount) > 0 ? (
                              <tr>
                                <td style={styles.tableTdRigthInner}>
                                  {this.state.company_setting !== null
                                    ? NumberUtil.addCommas(
                                        this.state.gearbox_amount
                                      )
                                    : 0}
                                </td>
                              </tr>
                            ) : null}
                            {port === 9035 &&
                            Number(this.state.debt_insurance_amount) > 0 ? (
                              <tr>
                                <td style={styles.tableTdRigthInner}>
                                  {this.state.company_setting !== null
                                    ? NumberUtil.addCommas(
                                        this.state.debt_insurance_amount
                                      )
                                    : 0}
                                </td>
                              </tr>
                            ) : null}

                            <tr>
                              <td>&nbsp;</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <td style={styles.amountsText} width={"63%"}>
                        {this.state.company_setting !== null
                          ? ThaiBaht(this.state.tax_invoice_total)
                          : 0}
                      </td>
                      <td style={styles.tableTdRigth} width={"18%"}>
                        รวมราคาทั้งสิ้น &nbsp;
                      </td>
                      <td style={styles.tableTdRigth}>
                        {/*{ NumberUtil.addCommas(parseFloat(this.state.tax_invoice_amount).toFixed(2).toString())}*/}

                        {this.state.car_sell_type_id === 1 ? (
                          <NumberFormat
                            className="form-control text-right"
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            //prefix={'฿'}
                            //placeholder="กรอกค่าโอน"
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.tax_invoice_amount}
                            displayType={"text"}
                          />
                        ) : (
                          <NumberFormat
                            className="form-control text-right"
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            //prefix={'฿'}
                            //placeholder="กรอกค่าโอน"
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.tax_invoice_amount}
                            onValueChange={(values) => {
                              const { value } = values;
                              this.setState(
                                { tax_invoice_amount: value },
                                () => {
                                  this.calInvoice();
                                }
                              );
                            }}
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <td style={styles.amountsTextNoBorder} width={"63%"}>
                        จำนวนเงินทั้งสิ้น (ตัวอักษร)
                      </td>
                      <td style={styles.tableTdRigth} width={"18%"}>
                        ภาษีมูลค่าเพิ่ม {vatPercent}%&nbsp;
                      </td>
                      <td style={styles.tableTdRigth} width={"19%"}>
                        {this.state.company_setting !== null
                          ? NumberUtil.addCommas(
                              this.state.tax_invoice_vat.toFixed(2).toString()
                            )
                          : 0}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table style={styles.table} className="mb-5">
                  <tbody>
                    <tr>
                      <td style={styles.amountsTextNoBorder} width={"63%"} />
                      <td style={styles.amountsRigth} width={"18%"}>
                        จำนวนรวมเงินทั้งสิ้น &nbsp;
                      </td>
                      <td style={styles.amountsRigth} width={"19%"}>
                        {this.genNetTotal()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="row">
                <div className="col-12 form-inline">
                  <input
                    type="checkbox"
                    className="form-control"
                    name={"use_old_license"}
                    value={this.state.use_old_license}
                    checked={this.state.use_old_license === 1}
                    onChange={(e) => {
                      let val = Number(e.target.value) === 0 ? 1 : 0;

                      this.setState({
                        use_old_license: val,
                      });
                    }}
                  />{" "}
                  &nbsp;&nbsp; ใช้ทะเบียนเดิม
                </div>
              </div>

              <div
                className={
                  port === 9038 || port === 9039 ? "hidden" : "row mt-5 mb-3"
                }
              >
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          ลงชื่อ...............................................................................ผู้รับเงิน
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          type="text"
                          style={{ ...styles.inputData, width: 380 }}
                          className="form-control mb-2"
                          placeholder=""
                          value={this.state.tax_invoice_payee || ""}
                          onChange={(e) => {
                            let val = e.target.value;
                            this.setState({
                              tax_invoice_payee: val,
                            });
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-md-12 text-right">
                <div className="card-block">
                  {/*<button type="reset"
                          className="btn btn-md btn-danger mr-2"
                          // onClick={this.props.onToggle}
                          style={{width: 120}}
                  >
                    <i className="fa fa-refresh"/> ยกเลิก
                  </button>*/}

                  {company_setting !== null && is_vat === 0 ? null : (
                    <>
                      <button
                        type="button"
                        className={
                          this.state.tax_invoice_status === "cancel"
                            ? "hidden"
                            : "btn btn-success btn-md mr-2"
                        }
                        style={{ width: 120 }}
                        onClick={() => this.saveTaxInvoice()}
                      >
                        <i className="icon-check" />
                        {this.state.isExist ? " แก้ไข" : " บันทึก"}
                      </button>
                    </>
                  )}

                  {this.state.isExist &&
                    this.state.tax_invoice_status === "normal" && (
                      <button
                        type="button"
                        className="btn btn-primary btn-md mr-2"
                        style={{ width: 120 }}
                        onClick={() => {
                          if (Number(port) === 9008) {
                            // roddee
                            this.printTaxInvoice(false);

                            setTimeout(() => {
                              this.printTaxInvoice(true);
                            }, 1000);
                          } else if (Number(port) === 9021) {
                            // ber1rodban, sompong
                            this.printTaxInvoice2(false);

                            setTimeout(() => {
                              this.printTaxInvoice2(true);
                            }, 1000);
                          } else if (
                            Number(port) === 9038 ||
                            Number(port) === 9039
                          ) {
                            // kmhomecar // thadyonauto
                            this.printTaxInvoiceCodeItem(false);

                            setTimeout(() => {
                              this.printTaxInvoiceCodeItem(true);
                            }, 1000);
                          } else if (Number(port) === 9048) {
                            // scauto
                            this.printTaxInvoiceNoModelNoSubModel(false);

                            setTimeout(() => {
                              this.printTaxInvoiceNoModelNoSubModel(true);
                            }, 1000);
                          } else if (Number(port) === 9036) {
                            // picar
                            this.printTaxInvoiceNoShowCustomer(false);

                            setTimeout(() => {
                              this.printTaxInvoiceNoShowCustomer(true);
                            }, 1000);
                          } else if (Number(port) === 9043) {
                            // atcar
                            this.printTaxInvoiceNoLine(false);

                            setTimeout(() => {
                              this.printTaxInvoiceNoLine(true);
                            }, 1000);
                          } else {
                            this.printTaxInvoice(false);
                          }
                        }}
                      >
                        <i className="icon-printer" /> พิมพ์
                      </button>
                    )}

                  {this.state.isExist &&
                    this.state.tax_invoice_status === "normal" && (
                      <button
                        type="button"
                        className="btn btn-warning btn-md mr-2"
                        style={{ width: 120 }}
                        onClick={() => {
                          if (Number(port) === 9021) {
                            this.printTaxInvoice2(true);
                          } else if (
                            Number(port) === 9038 ||
                            Number(port) === 9039
                          ) {
                            this.printTaxInvoiceCodeItem(true);
                          } else if (Number(port) === 9048) {
                            this.printTaxInvoiceNoModelNoSubModel(true);
                          } else if (Number(port) === 9036) {
                            this.printTaxInvoiceNoShowCustomer(true);
                          } else if (Number(port) === 9043) {
                            this.printTaxInvoiceNoLine(true);
                          } else {
                            this.printTaxInvoice(true);
                          }
                        }}
                      >
                        <i className="icon-printer" /> พิมพ์สำเนา
                      </button>
                    )}

                  {this.state.isExist &&
                    this.state.tax_invoice_status === "normal" && (
                      <button
                        type="button"
                        className="btn btn-danger btn-md"
                        style={{ width: 120 }}
                        onClick={() => this.cancelTaxInvoice("cancel")}
                      >
                        <i className="icon-trash" /> ยกเลิก
                      </button>
                    )}

                  {this.state.isExist &&
                    this.state.tax_invoice_status === "cancel" && (
                      <button
                        type="button"
                        className="btn btn-primary btn-md"
                        style={{ width: 120 }}
                        onClick={() => this.cancelTaxInvoice("reuse")}
                      >
                        <i className="icon-action-undo" /> เปิดใช้งาน
                      </button>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  table: {
    width: "100%",
    maxWidth: "100%",
  },
  tdContentCenter: {
    textAlign: "center",
    verticalAlign: "middle",
  },
  tdContentRight: {
    textAlign: "right",
    verticalAlign: "middle",
    justifyContent: "right",
  },
  tdContentLeft: {
    textAlign: "left",
    verticalAlign: "middle",
  },
  tableTh: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "center",
    verticalAlign: "middle",
  },
  tableTdLeft: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "center",
    verticalAlign: "top",
  },
  tableTdCenter: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "left",
    verticalAlign: "middle",
    paddingLeft: "70px",
  },
  tableTdRigth: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "right",
    verticalAlign: "top",
  },
  tableTdRigthInner: {
    maxWidth: "100%",
    borderColor: "#fff",
    borderWidth: "0px",
    borderStyle: "solid",
    textAlign: "right",
    verticalAlign: "top",
    paddingRight: "8px",
  },
  tablePd: {
    paddingLeft: "50px",
    paddingRight: "50px",
    lineHeight: "2.2",
  },
  amountsText: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "bold",
  },
  amountsTextNoBorder: {
    maxWidth: "100%",
    textAlign: "center",
    verticalAlign: "middle",
  },
  amountsRigth: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "right",
    verticalAlign: "top",
    fontWeight: "bold",
  },
  buttonHeight: {
    height: 32,
  },
  inputData: {
    borderRadius: "5px",
    width: "450px",
  },
  inputDataNo: {
    borderRadius: "5px",
    width: "100px",
  },
  inputDataNum: {
    borderRadius: "5px",
    width: "156px",
  },
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(FinanceTaxInvoice);
